import { useQuery, UseQueryOptions, useMutation, UseMutationOptions } from 'react-query';
import { oapFetcher } from './oapFetcher';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AWSDate: string;
  AWSDateTime: string;
  AWSEmail: string;
  AWSIPAddress: string;
  AWSJSON: string;
  AWSPhone: string;
  AWSTime: string;
  AWSTimestamp: number;
  AWSURL: string;
};

export type AgeRestriction = {
  __typename?: 'AgeRestriction';
  enabled: Scalars['Boolean'];
};

export type AgeRestrictionInput = {
  enabled: Scalars['Boolean'];
};

export type AllergenPreSignedUrl = {
  __typename?: 'AllergenPreSignedUrl';
  url: Scalars['String'];
};

export type ApiError = ApiErrorInfoArray | ApiErrorInfoObject;

export type ApiErrorInfoArray = {
  __typename?: 'ApiErrorInfoArray';
  errorInfo?: Maybe<Array<Maybe<ErrorInfo>>>;
  errorType?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  path?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ApiErrorInfoObject = {
  __typename?: 'ApiErrorInfoObject';
  errorInfo?: Maybe<ErrorInfo>;
  errorType?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  path?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type BankAccount = {
  __typename?: 'BankAccount';
  accountNumber: Scalars['String'];
  name: Scalars['String'];
  routingNumber: Scalars['String'];
};

export type BankAccountInput = {
  accountNumber: Scalars['String'];
  name: Scalars['String'];
  routingNumber: Scalars['String'];
};

export type Branding = {
  __typename?: 'Branding';
  accent: Scalars['String'];
  background: Scalars['String'];
  banner: Scalars['String'];
  primary: Scalars['String'];
  primaryText: Scalars['String'];
  text: Scalars['String'];
};

export type BrandingPalette = {
  __typename?: 'BrandingPalette';
  accentColor: Scalars['String'];
  backgroundColor: Scalars['String'];
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  primaryColor: Scalars['String'];
  primaryTextColor: Scalars['String'];
  textColor: Scalars['String'];
};

export type BrandingPaletteInput = {
  accentColor?: InputMaybe<Scalars['String']>;
  backgroundColor?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  primaryColor?: InputMaybe<Scalars['String']>;
  primaryTextColor?: InputMaybe<Scalars['String']>;
  textColor?: InputMaybe<Scalars['String']>;
};

export enum CalorieUnit {
  Kcals = 'KCALS'
}

export type Calories = {
  __typename?: 'Calories';
  amount: Scalars['Float'];
  unit: CalorieUnit;
};

export type CheckoutArtifact = {
  __typename?: 'CheckoutArtifact';
  contentType: Scalars['String'];
  createdAt: Scalars['String'];
  location: Scalars['String'];
  name: Scalars['String'];
};

export type CheckoutCustomerPrompt = {
  __typename?: 'CheckoutCustomerPrompt';
  promptText?: Maybe<Scalars['String']>;
  promptType: CustomerPromptTypes;
  required: Scalars['Boolean'];
};

export type CheckoutCustomerPromptInput = {
  promptText?: InputMaybe<Scalars['String']>;
  promptType: CustomerPromptTypes;
  required: Scalars['Boolean'];
};

export enum CheckoutStatus {
  Failed = 'FAILED',
  Paid = 'PAID',
  Pending = 'PENDING'
}

export type ChildItem = {
  __typename?: 'ChildItem';
  amount: Scalars['Int'];
  name: Scalars['String'];
  priceBookLine?: Maybe<OrderLinePriceBookLine>;
  quantity: Scalars['Int'];
};

export type ChildItemInput = {
  amount: Scalars['Int'];
  name: Scalars['String'];
  priceBookLine?: InputMaybe<PriceBookLineInput>;
  product: LineItemProduct;
  quantity: Scalars['Int'];
};

export type CollectionPoint = {
  __typename?: 'CollectionPoint';
  id: Scalars['String'];
  name: Scalars['String'];
  type: CollectionPointType;
};

export enum CollectionPointType {
  Counter = 'COUNTER',
  Table = 'TABLE'
}

export type CollectionPointsBatchCreateInput = {
  locationId: Scalars['String'];
  quantity: Scalars['Int'];
  type: CollectionPointType;
};

export enum CompletedOrderSource {
  Kiosk = 'KIOSK'
}

export type ConfigurationScheduleInput = {
  day: Scalars['String'];
  endTime: Scalars['String'];
  menus: Array<ScheduledMenuInput>;
  startTime: Scalars['String'];
};

export enum ConfigurationState {
  Draft = 'DRAFT',
  Live = 'LIVE'
}

export type ContactDetails = {
  __typename?: 'ContactDetails';
  address?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type ContactDetailsInput = {
  address?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type CreateKioskInput = {
  locationId: Scalars['String'];
  name: Scalars['String'];
  templateId: Scalars['String'];
};

export enum Currency {
  Brl = 'BRL',
  Eur = 'EUR',
  Gbp = 'GBP',
  Usd = 'USD'
}

export type CustomerOrderInfo = {
  __typename?: 'CustomerOrderInfo';
  collectionPoint?: Maybe<CustomerOrderInfoCollectionPoint>;
  customerProvidedReference: Array<KeyValue>;
  orderType: CustomerOrderInfoOrderType;
};

export type CustomerOrderInfoCollectionPoint = {
  __typename?: 'CustomerOrderInfoCollectionPoint';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type CustomerOrderInfoCollectionPointInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type CustomerOrderInfoInput = {
  collectionPoint?: InputMaybe<CustomerOrderInfoCollectionPointInput>;
  customerProvidedReference: Array<KeyValueInput>;
  orderType: CustomerOrderInfoOrderTypeInput;
};

export type CustomerOrderInfoOrderType = {
  __typename?: 'CustomerOrderInfoOrderType';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type CustomerOrderInfoOrderTypeInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export enum CustomerPromptTypes {
  Buzzer = 'BUZZER',
  Email = 'EMAIL',
  FreeText = 'FREE_TEXT',
  Name = 'NAME',
  Sms = 'SMS'
}

export type DocumentVerificationInput = {
  token: Scalars['String'];
};

export type DocumentVerificationResult = {
  __typename?: 'DocumentVerificationResult';
  status: IdvSessionState;
};

export type DummyPosConfig = {
  __typename?: 'DummyPosConfig';
  storeId?: Maybe<Scalars['String']>;
};

export type ErrorInfo = {
  __typename?: 'ErrorInfo';
  captured?: Maybe<Scalars['Boolean']>;
  field?: Maybe<Array<Maybe<Scalars['String']>>>;
  message?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type FacialAgeEstimationResult = {
  __typename?: 'FacialAgeEstimationResult';
  accepted: Scalars['Boolean'];
  age: Scalars['Float'];
  ageStdDev: Scalars['Float'];
  antiSpoofingResult?: Maybe<Scalars['String']>;
};

export type Feature = {
  __typename?: 'Feature';
  enabled: Scalars['Boolean'];
  feature: Scalars['String'];
};

export type FeatureFlags = {
  __typename?: 'FeatureFlags';
  features: Array<Feature>;
};

export type FileUpload = {
  __typename?: 'FileUpload';
  requestHeaders: Array<KeyValue>;
  url: Scalars['String'];
};

export type FiscalizationFailureDetails = {
  __typename?: 'FiscalizationFailureDetails';
  message: Scalars['String'];
};

export type FiscalizationFailureDetailsInput = {
  message: Scalars['String'];
};

export type FiscalizationReceiptAdditions = {
  __typename?: 'FiscalizationReceiptAdditions';
  digital: FiscalizationReceiptText;
  physical: FiscalizationReceiptText;
};

export type FiscalizationReceiptAdditionsInput = {
  digital: FiscalizationReceiptTextInput;
  physical: FiscalizationReceiptTextInput;
};

export type FiscalizationReceiptText = {
  __typename?: 'FiscalizationReceiptText';
  footer?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
};

export type FiscalizationReceiptTextInput = {
  footer?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<Scalars['String']>;
};

export type FiscalizationResult = {
  __typename?: 'FiscalizationResult';
  failureDetails?: Maybe<FiscalizationFailureDetails>;
  fiscalizedAt: Scalars['String'];
  metadata: Array<KeyValue>;
  provider: Scalars['String'];
  receiptAdditions?: Maybe<FiscalizationReceiptAdditions>;
  receiptId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type FiscalizationResultInput = {
  failureDetails?: InputMaybe<FiscalizationFailureDetailsInput>;
  fiscalizedAt: Scalars['String'];
  metadata: Array<KeyValueInput>;
  provider: Scalars['String'];
  receiptAdditions?: InputMaybe<FiscalizationReceiptAdditionsInput>;
  receiptId?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
};

export type FiveStarsOfferConnectionAuth = {
  __typename?: 'FiveStarsOfferConnectionAuth';
  apiKey?: Maybe<Scalars['String']>;
  apiSecret?: Maybe<Scalars['String']>;
};

export type FulfilmentDetail = {
  __typename?: 'FulfilmentDetail';
  fulfilmentType: FulfilmentType;
  id: Scalars['String'];
  priceBook: FulfilmentDetailPriceBook;
  reference?: Maybe<Scalars['String']>;
};

export type FulfilmentDetailPriceBook = {
  __typename?: 'FulfilmentDetailPriceBook';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type FulfilmentDetailsInput = {
  fulfilmentType: FulfilmentType;
  id: Scalars['String'];
  priceBook: FulfilmentDetailsPriceBookInput;
  reference?: InputMaybe<Scalars['String']>;
};

export type FulfilmentDetailsPriceBookInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export enum FulfilmentType {
  Unknown = 'UNKNOWN'
}

export type GoodtillPosConfig = {
  __typename?: 'GoodtillPosConfig';
  clientId?: Maybe<Scalars['String']>;
  outletId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export enum IdvSessionState {
  Complete = 'COMPLETE',
  Error = 'ERROR',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Unknown = 'UNKNOWN'
}

export type IdRecord = {
  __typename?: 'IdRecord';
  id: Scalars['String'];
};

export type IdentityVerificationSessionResult = {
  __typename?: 'IdentityVerificationSessionResult';
  identityVerificationUrl: Scalars['String'];
  sessionId: Scalars['String'];
};

export type ImageAgeEstimationInput = {
  imageBase64: Scalars['String'];
};

export type KdsConnection = {
  __typename?: 'KdsConnection';
  config?: Maybe<KdsConnectionConfig>;
  id: Scalars['String'];
  kdsSystem: KdsSystem;
  name: Scalars['String'];
};

export type KdsConnectionConfig = TickncookKdsConfig;

export type KdsConnectionConfigInput = {
  clientId?: InputMaybe<Scalars['String']>;
  clientSecret?: InputMaybe<Scalars['String']>;
};

export type KdsConnectionInput = {
  config?: InputMaybe<KdsConnectionConfigInput>;
  id?: InputMaybe<Scalars['String']>;
  kdsSystem: KdsSystem;
};

export enum KdsSystem {
  SumupKds = 'SUMUP_KDS',
  Tickncook = 'TICKNCOOK'
}

export type KeyValue = {
  __typename?: 'KeyValue';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type KeyValueInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type Kiosk = {
  __typename?: 'Kiosk';
  id: Scalars['String'];
  location: Location;
  name: Scalars['String'];
  template: KioskTemplate;
};

export type KioskAppearance = {
  __typename?: 'KioskAppearance';
  brandingId?: Maybe<Scalars['String']>;
  checkoutBannerUrl?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  screenSaverUrls: Array<Scalars['String']>;
  showAccessibilityControls: Scalars['Boolean'];
  showStartPrompt: Scalars['Boolean'];
};

export type KioskAppearanceInput = {
  brandingId?: InputMaybe<Scalars['String']>;
  checkoutBannerUrl?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  screenSaverUrls?: InputMaybe<Array<Scalars['String']>>;
  showAccessibilityControls?: InputMaybe<Scalars['Boolean']>;
  showStartPrompt?: InputMaybe<Scalars['Boolean']>;
};

export type KioskCollectionSlipOptions = {
  __typename?: 'KioskCollectionSlipOptions';
  enableDigitalSlips: Scalars['Boolean'];
  enablePrinting: Scalars['Boolean'];
  footerText?: Maybe<Scalars['String']>;
  headerText?: Maybe<Scalars['String']>;
  showPricesOnSlip: Scalars['Boolean'];
};

export type KioskCollectionSlipOptionsInput = {
  enableDigitalSlips?: InputMaybe<Scalars['Boolean']>;
  enablePrinting?: InputMaybe<Scalars['Boolean']>;
  footerText?: InputMaybe<Scalars['String']>;
  headerText?: InputMaybe<Scalars['String']>;
  showPricesOnSlip?: InputMaybe<Scalars['Boolean']>;
};

export type KioskKdsConfig = {
  __typename?: 'KioskKdsConfig';
  connection: KdsConnection;
  kitchenId: Scalars['String'];
};

export type KioskKdsConfigInput = {
  connectionId: Scalars['String'];
  kitchenId: Scalars['String'];
};

export type KioskOrderPreferences = {
  __typename?: 'KioskOrderPreferences';
  locale?: Maybe<Scalars['String']>;
  orderReferenceFormat: OrderReferenceFormat;
  orderTypes: Array<KioskOrderType>;
};

export type KioskOrderType = {
  __typename?: 'KioskOrderType';
  collectionPoints: Array<CollectionPoint>;
  color?: Maybe<Scalars['String']>;
  customerPrompts: Array<CheckoutCustomerPrompt>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  priceBook: PriceBook;
};

export type KioskSecurityControls = {
  __typename?: 'KioskSecurityControls';
  allowedMerchantIds: Array<Scalars['String']>;
  operatorMenuPin?: Maybe<Scalars['String']>;
};

export type KioskSecurityControlsInput = {
  allowedMerchantIds?: InputMaybe<Array<Scalars['String']>>;
  operatorMenuPin?: InputMaybe<Scalars['String']>;
};

export type KioskStrings = {
  __typename?: 'KioskStrings';
  kioskFooter?: Maybe<Scalars['String']>;
  orderConfirmation?: Maybe<Scalars['String']>;
};

export type KioskStringsInput = {
  kioskFooter?: InputMaybe<Scalars['String']>;
  orderConfirmation?: InputMaybe<Scalars['String']>;
};

export type KioskTemplate = {
  __typename?: 'KioskTemplate';
  allergenPdf?: Maybe<Scalars['String']>;
  appearance: KioskAppearance;
  branding: BrandingPalette;
  collectionSlipOptions: KioskCollectionSlipOptions;
  id: Scalars['String'];
  kdsConfig?: Maybe<KioskKdsConfig>;
  location: Location;
  name: Scalars['String'];
  offerConnections: Array<OfferConnection>;
  orderPreferences: KioskOrderPreferences;
  schedule: Schedule;
  securityControls: KioskSecurityControls;
  state: ConfigurationState;
  strings: KioskStrings;
};

export type KioskTemplateDetails = {
  __typename?: 'KioskTemplateDetails';
  allergenPdf?: Maybe<Scalars['String']>;
  defaultLocale?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  kdsConfig?: Maybe<KioskKdsConfig>;
  locationId: Scalars['String'];
  locationName: Scalars['String'];
  name: Scalars['String'];
  offerConnectionIds: Array<Scalars['String']>;
  state: ConfigurationState;
};

export type KioskTemplateDetailsCreateInput = {
  defaultLocale?: InputMaybe<Scalars['String']>;
  locationId: Scalars['String'];
  name: Scalars['String'];
};

export type KioskTemplateDetailsUpdateInput = {
  allergenPdf?: InputMaybe<Scalars['String']>;
  defaultLocale?: InputMaybe<Scalars['String']>;
  kdsConfig?: InputMaybe<KioskKdsConfigInput>;
  name?: InputMaybe<Scalars['String']>;
  offerConnectionIds?: InputMaybe<Array<Scalars['String']>>;
};

export type KioskTemplateHeader = {
  __typename?: 'KioskTemplateHeader';
  id: Scalars['String'];
  locationId: Scalars['String'];
  name: Scalars['String'];
  state: ConfigurationState;
};

export type LineItem = {
  __typename?: 'LineItem';
  amount: Scalars['Int'];
  amountDiscountTotal?: Maybe<Scalars['Int']>;
  childItems: Array<ChildItem>;
  fulfilmentDetailId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  posId?: Maybe<Scalars['String']>;
  priceBookLine?: Maybe<OrderLinePriceBookLine>;
  quantity: Scalars['Int'];
  taxDiscountTotal?: Maybe<Scalars['Int']>;
  taxItems: Array<TaxItem>;
};

export type LineItemInput = {
  amount: Scalars['Int'];
  amountDiscountTotal?: InputMaybe<Scalars['Int']>;
  childItems: Array<ChildItemInput>;
  createdAt: Scalars['String'];
  fulfilmentDetailId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  priceBookLine?: InputMaybe<PriceBookLineInput>;
  product: LineItemProduct;
  quantity: Scalars['Int'];
  taxDiscountTotal?: InputMaybe<Scalars['Int']>;
  taxItems: Array<TaxItemInput>;
};

export type LineItemProduct = {
  id?: InputMaybe<Scalars['String']>;
};

export type Location = {
  __typename?: 'Location';
  id: Scalars['String'];
  kioskTemplates: Array<KioskTemplate>;
  kiosks: Array<Kiosk>;
  menuUrl?: Maybe<Scalars['String']>;
  merchant: Merchant;
  name: Scalars['String'];
  posConnection?: Maybe<PosConnection>;
  qrCodes: Array<QrCode>;
  serviceChargeConfiguration: ServiceChargeConfiguration;
  terminals: Array<Terminal>;
};

export type LocationInput = {
  id?: InputMaybe<Scalars['String']>;
  menuUrl?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  posConnectionId?: InputMaybe<Scalars['String']>;
  serviceChargeConfiguration: ServiceChargeConfigurationInput;
};

export type Menu = {
  __typename?: 'Menu';
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  location: Location;
  name: Scalars['String'];
  sections: Array<MenuSection>;
};

export type MenuInput = {
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  locationId: Scalars['String'];
  name: Scalars['String'];
  sections: Array<MenuSectionsInput>;
};

export type MenuScheduleEntry = {
  __typename?: 'MenuScheduleEntry';
  day: Scalars['String'];
  endTime: Scalars['String'];
  menus: Array<Menu>;
  startTime: Scalars['String'];
};

export type MenuSection = {
  __typename?: 'MenuSection';
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  selectedProducts: Array<MenuSelectedProduct>;
};

export type MenuSectionsInput = {
  id: Scalars['String'];
  image?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  selectedProducts: Array<MenuSelectedProductInput>;
};

export type MenuSelectedProduct = {
  __typename?: 'MenuSelectedProduct';
  productId: Scalars['String'];
};

export type MenuSelectedProductInput = {
  productId: Scalars['String'];
};

export type Merchant = {
  __typename?: 'Merchant';
  businessName: Scalars['String'];
  code?: Maybe<Scalars['String']>;
  contactDetails?: Maybe<MerchantContactDetails>;
  countryCode: Scalars['String'];
  createdAt: Scalars['String'];
  currency: Currency;
  featureFlags: FeatureFlags;
  id: Scalars['String'];
  kdsConnections: Array<KdsConnection>;
  kycSubmittedAt?: Maybe<Scalars['String']>;
  locations: Array<Location>;
  offerConnections: Array<OfferConnection>;
  paymentConfiguration?: Maybe<PaymentConfiguration>;
  payments?: Maybe<PaymentList>;
  posConnections: Array<PosConnection>;
  qrCodesOrders?: Maybe<QrCodesOrderList>;
  servicePaymentProcessors: ServicePaymentProcessors;
  status: MerchantStatus;
  terminalConfigurations: Array<TerminalConfiguration>;
};


export type MerchantPaymentsArgs = {
  listQuery?: InputMaybe<PaymentListQuery>;
};


export type MerchantQrCodesOrdersArgs = {
  listQuery?: InputMaybe<QrCodesOrderListQuery>;
};

export type MerchantContactDetails = {
  __typename?: 'MerchantContactDetails';
  emailAddress?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type MerchantInput = {
  businessName: Scalars['String'];
  countryCode: Scalars['String'];
  currency: Currency;
};

export type MerchantLeadSummary = {
  __typename?: 'MerchantLeadSummary';
  largeLead: Scalars['Boolean'];
};

export type MerchantList = {
  __typename?: 'MerchantList';
  items?: Maybe<Array<Merchant>>;
  nextToken?: Maybe<Scalars['String']>;
  pageSize?: Maybe<Scalars['Int']>;
};

export type MerchantListQuery = {
  businessName?: InputMaybe<Scalars['String']>;
  nextToken?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type MerchantStatus = {
  __typename?: 'MerchantStatus';
  paymentsEnabled: Scalars['Boolean'];
};

export type ModifierSet = {
  __typename?: 'ModifierSet';
  id: Scalars['String'];
  name: Scalars['String'];
  variants: Array<ProductVariant>;
};

export type ModifierSetCreateInput = {
  locationId: Scalars['String'];
  name: Scalars['String'];
  variantIds: Array<Scalars['String']>;
};

export type ModifierSetPatchInput = {
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  variantIds?: InputMaybe<Array<Scalars['String']>>;
};

export type MoneyOffBasketRedeemable = {
  __typename?: 'MoneyOffBasketRedeemable';
  amount: Scalars['Int'];
  type: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  batchCreateCollectionPoints: Array<CollectionPoint>;
  checkCheckoutStatus: SumUpCheckout;
  checkPaymentStatus: Payment;
  checkPaymentStatusV2: StorePayment;
  createIdentityVerificationSession: IdentityVerificationSessionResult;
  createKiosk: Kiosk;
  createKioskTemplate: KioskTemplate;
  createMerchant: Merchant;
  createModifierSet: ModifierSet;
  createOrder: IdRecord;
  createPayment: Payment;
  createPaymentRefund: Payment;
  createQrCodesOrder: QrCodesOrder;
  createStorefrontConfiguration: StorefrontStoreDetails;
  createSumUpApiKey: SecretMetaData;
  deleteOrderType: Scalars['Boolean'];
  deleteQrCode?: Maybe<Scalars['Boolean']>;
  fetchAllergenPreSignedUrl: AllergenPreSignedUrl;
  fetchNextOrderNumber: Scalars['Int'];
  fetchPreSignedUrl: Scalars['String'];
  generateLocationQrCodes: Array<QrCode>;
  getLocationMenuUploadUrl: FileUpload;
  patchBranding: BrandingPalette;
  patchConfigurationOrderPreferences: OrderPreferences;
  patchConfigurationScheduledLayouts: Array<MenuScheduleEntry>;
  patchKiosk: Kiosk;
  patchKioskAppearance: KioskAppearance;
  patchKioskTemplateDetails: KioskTemplate;
  patchModifierSet: ModifierSet;
  patchOrderType: OrderType;
  patchStorefrontAppearance: StorefrontAppearance;
  patchStorefrontDetails: StorefrontStoreDetails;
  patchStorefrontReceiptStrings: StorefrontReceiptStrings;
  patchStorefrontSlugs: StorefrontSlugs;
  patchStorefrontStrings: StorefrontStrings;
  patchVariant: Scalars['Boolean'];
  putKdsConnection: KdsConnection;
  putKioskCollectionSlipOptions: KioskCollectionSlipOptions;
  putKioskSecurityControls: KioskSecurityControls;
  putKioskStrings: KioskStrings;
  putKyc: StripeKyc;
  putLocation: Location;
  putMenu: Menu;
  putOfferConnection: OfferConnection;
  putPaymentSetup: PaymentSetup;
  putPayoutBankAccount?: Maybe<BankAccount>;
  putPosConnection: PosConnection;
  putPriceBook: PriceBook;
  putQrCode: QrCode;
  putScreenLayout: ScreenLayout;
  putStatementDescriptor: Scalars['String'];
  putTerminal: Terminal;
  putTerminalConfiguration: TerminalConfiguration;
  putTerminalSchedule: Array<TerminalSchedule>;
  registerMerchantConsent: Scalars['Boolean'];
  registerOrder: IdRecord;
  registerUserForOnboarding: RegisterUserForOnboarding;
  requestReceipt: RequestReceiptResult;
  setActive: Scalars['Boolean'];
  setActiveMerchant: Scalars['Boolean'];
  startPayment: Payment;
  startPaymentForNewOrder: StorePayment;
  startPixPayment: PixCheckout;
  submitKyc?: Maybe<Scalars['Boolean']>;
  updateMerchantOnboardingInformation: Scalars['Boolean'];
};


export type MutationBatchCreateCollectionPointsArgs = {
  batchCreateDetails: CollectionPointsBatchCreateInput;
};


export type MutationCheckCheckoutStatusArgs = {
  checkoutId: Scalars['String'];
};


export type MutationCheckPaymentStatusArgs = {
  merchantId: Scalars['String'];
  paymentId: Scalars['String'];
};


export type MutationCheckPaymentStatusV2Args = {
  paymentId: Scalars['String'];
};


export type MutationCreateIdentityVerificationSessionArgs = {
  orderId: Scalars['String'];
  terminalId: Scalars['String'];
};


export type MutationCreateKioskArgs = {
  kiosk: CreateKioskInput;
};


export type MutationCreateKioskTemplateArgs = {
  kioskTemplateDetails: KioskTemplateDetailsCreateInput;
};


export type MutationCreateMerchantArgs = {
  merchant: MerchantInput;
};


export type MutationCreateModifierSetArgs = {
  modifierSet: ModifierSetCreateInput;
};


export type MutationCreateOrderArgs = {
  order: OrderInput;
};


export type MutationCreatePaymentArgs = {
  merchantId: Scalars['String'];
  orderId: Scalars['String'];
  payment: PaymentInput;
  paymentProcessorData: PaymentProcessorInput;
};


export type MutationCreatePaymentRefundArgs = {
  refund: RefundInput;
};


export type MutationCreateQrCodesOrderArgs = {
  businessName?: InputMaybe<Scalars['String']>;
  contactDetails: ContactDetailsInput;
  type: QrCodesType;
};


export type MutationCreateStorefrontConfigurationArgs = {
  storeDetails: StorefrontStoreDetailsCreateInput;
};


export type MutationDeleteOrderTypeArgs = {
  id: Scalars['String'];
};


export type MutationDeleteQrCodeArgs = {
  locationId: Scalars['String'];
  qrCodeId: Scalars['String'];
};


export type MutationFetchAllergenPreSignedUrlArgs = {
  fileSize: Scalars['Int'];
  mimeType: Scalars['String'];
  terminalConfigId: Scalars['String'];
};


export type MutationFetchNextOrderNumberArgs = {
  locationId: Scalars['String'];
  merchantId: Scalars['String'];
};


export type MutationFetchPreSignedUrlArgs = {
  fileName: Scalars['String'];
  fileSize: Scalars['Int'];
  mimeType: Scalars['String'];
};


export type MutationGenerateLocationQrCodesArgs = {
  locationId: Scalars['String'];
  merchantId: Scalars['String'];
};


export type MutationGetLocationMenuUploadUrlArgs = {
  locationId: Scalars['String'];
};


export type MutationPatchBrandingArgs = {
  branding: BrandingPaletteInput;
  id?: InputMaybe<Scalars['String']>;
};


export type MutationPatchConfigurationOrderPreferencesArgs = {
  configurationId: Scalars['String'];
  orderPreferences: OrderPreferenceInput;
};


export type MutationPatchConfigurationScheduledLayoutsArgs = {
  configurationId: Scalars['String'];
  schedule: Array<ConfigurationScheduleInput>;
};


export type MutationPatchKioskArgs = {
  kiosk: PatchKioskInput;
  kioskId: Scalars['String'];
};


export type MutationPatchKioskAppearanceArgs = {
  appearance: KioskAppearanceInput;
  kioskTemplateId: Scalars['String'];
};


export type MutationPatchKioskTemplateDetailsArgs = {
  kioskTemplateDetails: KioskTemplateDetailsUpdateInput;
  kioskTemplateId: Scalars['String'];
};


export type MutationPatchModifierSetArgs = {
  modifierSet: ModifierSetPatchInput;
};


export type MutationPatchOrderTypeArgs = {
  orderType: OrderTypeUpdateInput;
};


export type MutationPatchStorefrontAppearanceArgs = {
  appearance: StorefrontAppearanceInput;
  storefrontId: Scalars['String'];
};


export type MutationPatchStorefrontDetailsArgs = {
  storeDetails: StorefrontStoreDetailsUpdateInput;
  storefrontId: Scalars['String'];
};


export type MutationPatchStorefrontReceiptStringsArgs = {
  receiptStrings: StorefrontReceiptStringsInput;
  storefrontId: Scalars['String'];
};


export type MutationPatchStorefrontSlugsArgs = {
  slugs: StorefrontSlugsInput;
  storefrontId: Scalars['String'];
};


export type MutationPatchStorefrontStringsArgs = {
  storefrontId: Scalars['String'];
  strings: StorefrontStringsInput;
};


export type MutationPatchVariantArgs = {
  variant: ProductVariantUpdateInput;
};


export type MutationPutKdsConnectionArgs = {
  kdsConnection: KdsConnectionInput;
};


export type MutationPutKioskCollectionSlipOptionsArgs = {
  collectionSlipOptions: KioskCollectionSlipOptionsInput;
  kioskTemplateId: Scalars['String'];
};


export type MutationPutKioskSecurityControlsArgs = {
  kioskTemplateId: Scalars['String'];
  securityControls: KioskSecurityControlsInput;
};


export type MutationPutKioskStringsArgs = {
  kioskTemplateId: Scalars['String'];
  strings: KioskStringsInput;
};


export type MutationPutKycArgs = {
  data: StripeKycInput;
};


export type MutationPutLocationArgs = {
  location: LocationInput;
};


export type MutationPutMenuArgs = {
  menu: MenuInput;
};


export type MutationPutOfferConnectionArgs = {
  offerConnection?: InputMaybe<OfferConnectionInput>;
};


export type MutationPutPaymentSetupArgs = {
  merchantId: Scalars['String'];
  orderId: Scalars['String'];
  payment: PaymentInput;
  paymentProcessorData?: InputMaybe<PaymentProcessorInput>;
};


export type MutationPutPayoutBankAccountArgs = {
  bankAccount: BankAccountInput;
};


export type MutationPutPosConnectionArgs = {
  posConnection: PosConnectionInput;
};


export type MutationPutPriceBookArgs = {
  priceBook: PriceBookInput;
};


export type MutationPutQrCodeArgs = {
  locationId: Scalars['String'];
  qrCode: QrCodeInput;
};


export type MutationPutScreenLayoutArgs = {
  screenLayout: ScreenLayoutInput;
};


export type MutationPutStatementDescriptorArgs = {
  statementDescriptor: Scalars['String'];
};


export type MutationPutTerminalArgs = {
  locationId: Scalars['String'];
  terminal: TerminalInput;
};


export type MutationPutTerminalConfigurationArgs = {
  terminalConfiguration: TerminalConfigurationInput;
};


export type MutationPutTerminalScheduleArgs = {
  schedule: Array<TerminalScheduleInput>;
  terminalConfigurationId: Scalars['String'];
};


export type MutationRegisterOrderArgs = {
  order: OrderCompletedInput;
};


export type MutationRequestReceiptArgs = {
  input: RequestReceiptInput;
};


export type MutationSetActiveArgs = {
  kioskTemplateId: Scalars['String'];
};


export type MutationSetActiveMerchantArgs = {
  merchantId: Scalars['String'];
};


export type MutationStartPaymentArgs = {
  merchantId: Scalars['String'];
  orderId: Scalars['String'];
  payment: PaymentInput;
  redirectUrl: Scalars['String'];
};


export type MutationStartPaymentForNewOrderArgs = {
  order: StoreOrderInput;
  storeUrl: Scalars['String'];
};


export type MutationStartPixPaymentArgs = {
  payment: StartPixPayment;
};


export type MutationUpdateMerchantOnboardingInformationArgs = {
  information: OnboardingInformationInput;
};

export type NotificationConfig = {
  __typename?: 'NotificationConfig';
  smsEnabled: Scalars['Boolean'];
};

export type Offer = {
  __typename?: 'Offer';
  id: Scalars['String'];
  name: Scalars['String'];
  pointsRequired: Scalars['Int'];
  redeemable: Array<Redeemable>;
};

export type OfferConnection = {
  __typename?: 'OfferConnection';
  auth: OfferConnectionAuth;
  behaviour: OfferConnectionBehaviour;
  config: OfferConnectionConfig;
  createdAt: Scalars['String'];
  id: Scalars['String'];
  type: Scalars['String'];
};

export type OfferConnectionAuth = FiveStarsOfferConnectionAuth;

export type OfferConnectionBehaviour = {
  __typename?: 'OfferConnectionBehaviour';
  offerType: Scalars['String'];
  signIn?: Maybe<OfferConnectionSignInBehaviour>;
};

export type OfferConnectionConfig = {
  __typename?: 'OfferConnectionConfig';
  businessIdentifier?: Maybe<Scalars['String']>;
};

export type OfferConnectionConfigInput = {
  businessIdentifier?: InputMaybe<Scalars['String']>;
};

export type OfferConnectionInput = {
  config?: InputMaybe<OfferConnectionConfigInput>;
  id?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type OfferConnectionSignInBehaviour = {
  __typename?: 'OfferConnectionSignInBehaviour';
  type: Scalars['String'];
};

export type OfferDetails = {
  __typename?: 'OfferDetails';
  connectionId: Scalars['String'];
  redeemedOffers: Array<RedeemedOffer>;
};

export type OfferDetailsInput = {
  connectionId: Scalars['String'];
  redeemedOffers: Array<RedeemedOfferInput>;
  userIdentifier: Scalars['String'];
};

export type OfferUserIdentifier = {
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type OfferUserProfile = {
  __typename?: 'OfferUserProfile';
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  points: Scalars['Int'];
};

export type OnboardingInformationInput = {
  additionalInformation?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Scalars['String']>;
  kds?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
  productsInterestedIn?: InputMaybe<Array<Scalars['String']>>;
  totalKiosks?: InputMaybe<Scalars['String']>;
  turnover?: InputMaybe<Scalars['Int']>;
};

export type Order = {
  __typename?: 'Order';
  amount: Scalars['Int'];
  consumerId: Scalars['String'];
  currency: Currency;
  customerOrderInfo: Array<CustomerOrderInfo>;
  id: Scalars['String'];
  lineItems: Array<OrderLineItem>;
  locationId: Scalars['String'];
  merchantId: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  orderRef: Scalars['String'];
  payments: Array<StorePayment>;
  receiptConfiguration?: Maybe<StoreReceiptConfiguration>;
  serviceCharge?: Maybe<ServicePayment>;
  state: StoreOrderState;
  tax: Scalars['Int'];
  taxBreakdown: Array<TaxBreakdown>;
  terminalId: Scalars['String'];
};

export type OrderCompletedInput = {
  amount: Scalars['Int'];
  completedAt: Scalars['String'];
  consumerId?: InputMaybe<Scalars['String']>;
  contactDetails?: InputMaybe<StoreOrderContactDetailsInput>;
  currency: Currency;
  customerOrderInfo: Array<CustomerOrderInfoInput>;
  id: Scalars['String'];
  lineItems: Array<OrderCompletedLineInput>;
  metadata: Array<KeyValueInput>;
  notes?: InputMaybe<Scalars['String']>;
  orderRef: Scalars['String'];
  payments: Array<PaymentCompletedInput>;
  source: CompletedOrderSource;
  startedAt: Scalars['String'];
  state: OrderState;
  tax: Scalars['Int'];
  terminalId: Scalars['String'];
};

export type OrderCompletedLineInput = {
  amount: Scalars['Int'];
  createdAt: Scalars['String'];
  id: Scalars['String'];
  modifiers: Array<OrderCompletedModifierInput>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  orderTypeId: Scalars['String'];
  priceBookLine: PriceBookLineInput;
  productId?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
  taxItems: Array<TaxItemInput>;
};

export type OrderCompletedModifierInput = {
  amount: Scalars['Int'];
  name: Scalars['String'];
  priceBookLine: PriceBookLineInput;
  productId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type OrderHeader = {
  __typename?: 'OrderHeader';
  id?: Maybe<Scalars['String']>;
  locationId: Scalars['String'];
  merchantId: Scalars['String'];
};

export type OrderInput = {
  amount: Scalars['Int'];
  amountDiscountTotal?: InputMaybe<Scalars['Int']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  covers?: InputMaybe<Scalars['Int']>;
  currency: Currency;
  fulfilmentDetails?: InputMaybe<Array<FulfilmentDetailsInput>>;
  id: Scalars['String'];
  lineItems: Array<LineItemInput>;
  locationId: Scalars['String'];
  metadata?: InputMaybe<Array<KeyValueInput>>;
  notes?: InputMaybe<Scalars['String']>;
  offerDetails?: InputMaybe<OfferDetailsInput>;
  openedAt: Scalars['String'];
  payments: Array<PaymentCompleteInput>;
  posTableName?: InputMaybe<Scalars['String']>;
  reference: Scalars['String'];
  state?: InputMaybe<OrderState>;
  tax: Scalars['Int'];
  taxDiscountTotal?: InputMaybe<Scalars['Int']>;
  terminalId?: InputMaybe<Scalars['String']>;
};

export type OrderLineInput = {
  childItems?: InputMaybe<Array<OrderLineModifierInput>>;
  createdAt: Scalars['String'];
  externalId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  modifiers?: InputMaybe<Array<OrderLineModifierInput>>;
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  orderTypeId: Scalars['String'];
  priceBookLine: OrderPriceBookLineInput;
  productId?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
};

export type OrderLineItem = {
  __typename?: 'OrderLineItem';
  amount: Scalars['Int'];
  createdAt: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  modifiers: Array<OrderModifierItem>;
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  orderTypeId: Scalars['String'];
  priceBookLine: StorePriceBookLine;
  productId?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
  taxItems: Array<TaxItem>;
};

export type OrderLineModifierInput = {
  externalId: Scalars['String'];
  name: Scalars['String'];
  priceBookLine: OrderPriceBookLineInput;
  productId?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
};

export type OrderLinePriceBook = {
  __typename?: 'OrderLinePriceBook';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type OrderLinePriceBookLine = {
  __typename?: 'OrderLinePriceBookLine';
  amount: Scalars['Int'];
  priceBook: OrderLinePriceBook;
  taxRate: TaxRate;
};

export type OrderModifierItem = {
  __typename?: 'OrderModifierItem';
  amount: Scalars['Int'];
  externalId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  priceBookLine: StorePriceBookLine;
  productId?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
};

export type OrderPaymentIntention = {
  __typename?: 'OrderPaymentIntention';
  orderPaymentType: OrderPaymentType;
  partySize?: Maybe<Scalars['Int']>;
};

export type OrderPaymentIntentionInput = {
  orderPaymentType: OrderPaymentType;
  partySize?: InputMaybe<Scalars['Int']>;
};

export enum OrderPaymentType {
  Amount = 'AMOUNT',
  Full = 'FULL',
  Item = 'ITEM',
  Party = 'PARTY'
}

export type OrderPreferenceInput = {
  locale?: InputMaybe<Scalars['String']>;
  orderReferenceFormat?: InputMaybe<OrderReferenceFormat>;
  orderTypes?: InputMaybe<Array<OrderTypeConfigurationInput>>;
};

export type OrderPreferences = {
  __typename?: 'OrderPreferences';
  locale?: Maybe<Scalars['String']>;
  orderReferenceFormat?: Maybe<OrderReferenceFormat>;
  orderTypes: Array<OrderType>;
};

export type OrderPriceBookLineInput = {
  priceBook: PriceBookIdInput;
};

export enum OrderReferenceFormat {
  Alphanumeric = 'ALPHANUMERIC',
  Numeric = 'NUMERIC'
}

export enum OrderState {
  Closed = 'CLOSED',
  Deleted = 'DELETED',
  Open = 'OPEN',
  Unknown = 'UNKNOWN'
}

export type OrderType = {
  __typename?: 'OrderType';
  collectionPoints: Array<CollectionPoint>;
  color?: Maybe<Scalars['String']>;
  customerPrompts?: Maybe<Array<CheckoutCustomerPrompt>>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  priceBookId?: Maybe<Scalars['String']>;
};

export type OrderTypeConfigurationInput = {
  collectionPoints: Array<Scalars['String']>;
  customerPrompts: Array<CheckoutCustomerPromptInput>;
  id: Scalars['String'];
};

export type OrderTypeCustomerPrompt = {
  __typename?: 'OrderTypeCustomerPrompt';
  isRequired: Scalars['Boolean'];
  promptText: Scalars['String'];
  promptTitle: Scalars['String'];
};

export type OrderTypeUpdateInput = {
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  priceBookId?: InputMaybe<Scalars['String']>;
};

export type OrderV0 = {
  __typename?: 'OrderV0';
  amount: Scalars['Int'];
  amountDiscountTotal?: Maybe<Scalars['Int']>;
  completed: Scalars['Boolean'];
  covers?: Maybe<Scalars['Int']>;
  currency: Currency;
  fulfilmentDetails: Array<FulfilmentDetail>;
  hasDiscounts?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  lastRetrievedAt?: Maybe<Scalars['String']>;
  lineItems: Array<LineItem>;
  notes?: Maybe<Scalars['String']>;
  offerDetails?: Maybe<OfferDetails>;
  openedAt: Scalars['String'];
  orderPaymentIntention?: Maybe<OrderPaymentIntention>;
  payments: Array<Payment>;
  posId?: Maybe<Scalars['String']>;
  posPayments?: Maybe<Array<PosPayment>>;
  posReference?: Maybe<Scalars['String']>;
  posTableName?: Maybe<Scalars['String']>;
  receiptConfiguration?: Maybe<ReceiptConfiguration>;
  serviceCharge?: Maybe<ServiceCharge>;
  staff?: Maybe<Staff>;
  state: OrderState;
  tax: Scalars['Int'];
};

export type PatchKioskInput = {
  name?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['String']>;
};

export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['Int'];
  cardDetails?: Maybe<PaymentCardDetails>;
  consumerName?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  currency: Currency;
  fiscalization?: Maybe<FiscalizationResult>;
  id: Scalars['String'];
  lineItems?: Maybe<Array<PaymentLineItem>>;
  location?: Maybe<Location>;
  notes?: Maybe<Scalars['String']>;
  order?: Maybe<OrderV0>;
  orderId?: Maybe<Scalars['String']>;
  orderPaymentIntention?: Maybe<OrderPaymentIntention>;
  parties?: Maybe<Scalars['Int']>;
  paymentMethod?: Maybe<PaymentMethod>;
  processorMetadata?: Maybe<PaymentProcessorMetadata>;
  processorReference?: Maybe<Scalars['String']>;
  refunds: Array<Payment>;
  servicePayment?: Maybe<ServicePayment>;
  source: Source;
  state: PaymentState;
};

export type PaymentCardDetails = {
  __typename?: 'PaymentCardDetails';
  brand: Scalars['String'];
  last4: Scalars['String'];
  wallet?: Maybe<PaymentCardWallet>;
};

export type PaymentCardDetailsInput = {
  brand: Scalars['String'];
  last4: Scalars['String'];
  wallet?: InputMaybe<PaymentCardWallet>;
};

export enum PaymentCardWallet {
  AmexExpressCheckout = 'AMEX_EXPRESS_CHECKOUT',
  ApplePay = 'APPLE_PAY',
  GooglePay = 'GOOGLE_PAY',
  Masterpass = 'MASTERPASS',
  SamsungPay = 'SAMSUNG_PAY',
  VisaCheckout = 'VISA_CHECKOUT'
}

export type PaymentCompleteInput = {
  amount: Scalars['Int'];
  cardDetails?: InputMaybe<PaymentCardDetailsInput>;
  consumerName?: InputMaybe<Scalars['String']>;
  currency: Currency;
  fiscalization?: InputMaybe<FiscalizationResultInput>;
  lineItems?: InputMaybe<Array<PaymentLineItemInput>>;
  orderPaymentIntention: OrderPaymentIntentionInput;
  parties?: InputMaybe<Scalars['Int']>;
  paymentMethod?: InputMaybe<PaymentMethod>;
  processor?: InputMaybe<Scalars['String']>;
  processorMetadata?: InputMaybe<PaymentProcessorMetadataInput>;
  processorReference?: InputMaybe<Scalars['String']>;
  servicePayment?: InputMaybe<ServicePaymentInput>;
};

export type PaymentCompletedInput = {
  amount: Scalars['Int'];
  cardDetails?: InputMaybe<PaymentCardDetailsInput>;
  completedAt: Scalars['String'];
  currency: Currency;
  foreignTransactionId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  paymentMethod: PaymentMethod;
  processorDetails?: InputMaybe<ProcessorDetailsInput>;
  processorId: Scalars['String'];
  servicePayments: Array<ServicePaymentInput>;
};

export type PaymentConfiguration = {
  __typename?: 'PaymentConfiguration';
  accountId: Scalars['String'];
  enabled: Scalars['Boolean'];
  paymentProcessor: Scalars['String'];
  payoutBankAccount?: Maybe<BankAccount>;
  statementDescriptor?: Maybe<Scalars['String']>;
};

export type PaymentInput = {
  amount: Scalars['Int'];
  consumerName?: InputMaybe<Scalars['String']>;
  currency: Currency;
  id?: InputMaybe<Scalars['String']>;
  lineItems?: InputMaybe<Array<PaymentLineItemInput>>;
  orderPaymentIntention: OrderPaymentIntentionInput;
  parties?: InputMaybe<Scalars['Int']>;
  servicePayment?: InputMaybe<ServicePaymentInput>;
};

export type PaymentLineItem = {
  __typename?: 'PaymentLineItem';
  amount: Scalars['Int'];
  name: Scalars['String'];
  posId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type PaymentLineItemInput = {
  amount: Scalars['Int'];
  posId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type PaymentList = {
  __typename?: 'PaymentList';
  items?: Maybe<Array<Payment>>;
  nextToken?: Maybe<Scalars['String']>;
  pageSize?: Maybe<Scalars['Int']>;
};

export type PaymentListQuery = {
  createdAtEnd?: InputMaybe<Scalars['String']>;
  createdAtStart?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  nextToken?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
};

export enum PaymentMethod {
  Card = 'CARD'
}

export type PaymentProcessorInput = {
  stripePaymentIntentId?: InputMaybe<Scalars['String']>;
};

export type PaymentProcessorMetadata = {
  __typename?: 'PaymentProcessorMetadata';
  foreignTransactionId?: Maybe<Scalars['String']>;
  merchantId?: Maybe<Scalars['String']>;
  paymentIntentId?: Maybe<Scalars['String']>;
};

export type PaymentProcessorMetadataInput = {
  foreignTransactionId?: InputMaybe<Scalars['String']>;
  merchantId?: InputMaybe<Scalars['String']>;
};

export type PaymentSetup = {
  __typename?: 'PaymentSetup';
  paymentProcessor: Scalars['String'];
  stripePaymentIntent?: Maybe<StripePaymentIntent>;
};

export enum PaymentState {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS'
}

export type Payout = {
  __typename?: 'Payout';
  amount: Scalars['Int'];
  arrivalAt: Scalars['String'];
  createdAt: Scalars['String'];
  currency: Currency;
  descriptor?: Maybe<Scalars['String']>;
  failureMessage?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  status: PayoutStatus;
  transactions: TransactionList;
  type: Scalars['String'];
};


export type PayoutTransactionsArgs = {
  listQuery?: InputMaybe<TransactionListQuery>;
};

export type PayoutList = {
  __typename?: 'PayoutList';
  items?: Maybe<Array<Payout>>;
  nextToken?: Maybe<Scalars['String']>;
  pageSize?: Maybe<Scalars['Int']>;
};

export type PayoutListQuery = {
  arrivalAtFrom?: InputMaybe<Scalars['String']>;
  arrivalAtTo?: InputMaybe<Scalars['String']>;
  createdAtFrom?: InputMaybe<Scalars['String']>;
  createdAtTo?: InputMaybe<Scalars['String']>;
  destination?: InputMaybe<Scalars['String']>;
  nextToken?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
};

export enum PayoutStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  InTransit = 'IN_TRANSIT',
  Paid = 'PAID',
  Pending = 'PENDING'
}

export type PercentOffBasketRedeemable = {
  __typename?: 'PercentOffBasketRedeemable';
  percent: Scalars['Float'];
  type: Scalars['String'];
};

export type PixCheckout = {
  __typename?: 'PixCheckout';
  amount: Scalars['Int'];
  currency: Scalars['String'];
  id: Scalars['String'];
  merchantCode: Scalars['String'];
  pix: PixCheckoutDetails;
};

export type PixCheckoutDetails = {
  __typename?: 'PixCheckoutDetails';
  artefacts: Array<CheckoutArtifact>;
  type: Scalars['String'];
};

export type PosConnection = {
  __typename?: 'PosConnection';
  config: PosConnectionConfig;
  id: Scalars['String'];
  name: Scalars['String'];
  posSystem: PosSystem;
  refreshedAt?: Maybe<Scalars['String']>;
  status: PosConnectionStatus;
};

export type PosConnectionConfig = DummyPosConfig | GoodtillPosConfig | SumUpPosConfig | SumUpPosProConfig;

export type PosConnectionConfigInput = {
  code?: InputMaybe<Scalars['String']>;
  redirectUri?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

export type PosConnectionInput = {
  config: PosConnectionConfigInput;
  id?: InputMaybe<Scalars['String']>;
  posSystem: PosSystem;
};

export enum PosConnectionStatus {
  Active = 'ACTIVE',
  RequiresReconnect = 'REQUIRES_RECONNECT'
}

export type PosLocation = {
  __typename?: 'PosLocation';
  name: Scalars['String'];
  posReference: Scalars['String'];
};

export type PosOrderList = {
  __typename?: 'PosOrderList';
  location: Location;
  orders: Array<OrderHeader>;
  qrCode?: Maybe<QrCode>;
};

export type PosPayment = {
  __typename?: 'PosPayment';
  amount: Scalars['Int'];
  external: Scalars['Boolean'];
  paymentMethod: Scalars['String'];
};

export enum PosSystem {
  Dummy = 'DUMMY',
  Franpos = 'FRANPOS',
  Goodtill = 'GOODTILL',
  Sumup = 'SUMUP',
  SumupPosPro = 'SUMUP_POS_PRO'
}

export type PosTable = {
  __typename?: 'PosTable';
  area?: Maybe<Scalars['String']>;
  covers?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  posReference: Scalars['String'];
};

export type PriceBook = {
  __typename?: 'PriceBook';
  default: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type PriceBookIdInput = {
  id: Scalars['String'];
};

export type PriceBookInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type PriceBookLine = {
  __typename?: 'PriceBookLine';
  amount: Scalars['Int'];
  priceBook: PriceBook;
  taxRate: TaxRate;
};

export type PriceBookLineInput = {
  amount: Scalars['Int'];
  priceBook?: InputMaybe<PriceBookInput>;
  taxRate?: InputMaybe<TaxRateInput>;
};

export type ProcessorDetails = {
  __typename?: 'ProcessorDetails';
  paymentId?: Maybe<Scalars['String']>;
  paymentIntentId?: Maybe<Scalars['String']>;
  transactionCode?: Maybe<Scalars['String']>;
};

export type ProcessorDetailsInput = {
  merchantId?: InputMaybe<Scalars['String']>;
  paymentId?: InputMaybe<Scalars['String']>;
  paymentIntentId?: InputMaybe<Scalars['String']>;
  transactionCode?: InputMaybe<Scalars['String']>;
};

export type Product = {
  __typename?: 'Product';
  brand?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  images: Array<ProductImage>;
  name: Scalars['String'];
  variants: Array<ProductVariant>;
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  id: Scalars['String'];
  name: Scalars['String'];
  products: Array<Product>;
};

export type ProductId = {
  __typename?: 'ProductId';
  id: Scalars['String'];
};

export type ProductImage = {
  __typename?: 'ProductImage';
  url: Scalars['String'];
};

export type ProductInventory = {
  __typename?: 'ProductInventory';
  inventoryOnHand: Scalars['Int'];
  productId: Scalars['String'];
};

export type ProductInventoryComponent = {
  __typename?: 'ProductInventoryComponent';
  componentId: Scalars['String'];
  quantifier: Scalars['Float'];
};

export type ProductInventoryUnits = {
  __typename?: 'ProductInventoryUnits';
  inventoryOnHand: Scalars['Float'];
  productId: Scalars['String'];
};

export type ProductList = {
  __typename?: 'ProductList';
  items?: Maybe<Array<Product>>;
  nextToken?: Maybe<Scalars['String']>;
  pageSize?: Maybe<Scalars['Int']>;
};

export type ProductListQuery = {
  nextToken?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type ProductModifier = {
  __typename?: 'ProductModifier';
  id: Scalars['String'];
  maxQuantity?: Maybe<Scalars['Int']>;
  minQuantity?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  variants: Array<ProductVariantWithoutModifiers>;
};

export type ProductModifierInput = {
  maxQuantity?: InputMaybe<Scalars['Int']>;
  minQuantity?: InputMaybe<Scalars['Int']>;
  modifierSetId: Scalars['String'];
};

export type ProductVariant = {
  __typename?: 'ProductVariant';
  barcode?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  calories?: Maybe<Calories>;
  id: Scalars['String'];
  images: Array<ProductImage>;
  inventoryComponents?: Maybe<Array<ProductInventoryComponent>>;
  modifiers: Array<ProductModifier>;
  name: Scalars['String'];
  priceBookLines: Array<PriceBookLine>;
};

export type ProductVariantUpdateInput = {
  locationId: Scalars['String'];
  modifiers: Array<ProductModifierInput>;
  productId: Scalars['String'];
  variantId: Scalars['String'];
};

export type ProductVariantWithoutModifiers = {
  __typename?: 'ProductVariantWithoutModifiers';
  calories?: Maybe<Calories>;
  id: Scalars['String'];
  images: Array<ProductImage>;
  inventoryComponents?: Maybe<Array<ProductInventoryComponent>>;
  name: Scalars['String'];
  priceBookLines: Array<PriceBookLine>;
};

export type QrCode = {
  __typename?: 'QrCode';
  id: Scalars['String'];
  posTableReference: Scalars['String'];
  redirectToLinks?: Maybe<Scalars['Boolean']>;
  tableName: Scalars['String'];
};

export type QrCodeInput = {
  id: Scalars['String'];
  posTableReference: Scalars['String'];
  tableName: Scalars['String'];
};

export type QrCodesOrder = {
  __typename?: 'QrCodesOrder';
  contactDetails?: Maybe<ContactDetails>;
  merchantId: Scalars['String'];
  type: QrCodesType;
};

export type QrCodesOrderList = {
  __typename?: 'QrCodesOrderList';
  items?: Maybe<Array<QrCodesOrder>>;
  nextToken?: Maybe<Scalars['String']>;
  pageSize?: Maybe<Scalars['Int']>;
};

export type QrCodesOrderListQuery = {
  nextToken?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export enum QrCodesType {
  Stands = 'STANDS',
  VinylStickers = 'VINYL_STICKERS'
}

export type Query = {
  __typename?: 'Query';
  getAllergenPreSignedUrl: AllergenPreSignedUrl;
  getBrandings: Array<BrandingPalette>;
  getCompletedOrder?: Maybe<OrderV0>;
  getConfigurationOrderPreferences: OrderPreferences;
  getConfigurationScheduledLayouts: Array<MenuScheduleEntry>;
  getDocumentVerification: DocumentVerificationResult;
  getFacialAgeEstimation: FacialAgeEstimationResult;
  getFeatureFlags: FeatureFlags;
  getFeatureFlagsPublic: FeatureFlags;
  getImagePreSignedUrl: Scalars['String'];
  getKdsConnection: KdsConnection;
  getKdsConnections: Array<KdsConnection>;
  getKiosk: Kiosk;
  getKioskAppearance: KioskAppearance;
  getKioskCollectionSlipOptions: KioskCollectionSlipOptions;
  getKioskProductInventory: Array<ProductInventoryUnits>;
  getKioskProducts: ProductList;
  getKioskSecurityControls: KioskSecurityControls;
  getKioskStrings: KioskStrings;
  getKioskTemplate: KioskTemplate;
  getKioskTemplateDetails: KioskTemplateDetails;
  getKioskTemplateDetailsList: Array<KioskTemplateDetails>;
  getKioskTemplates: Array<KioskTemplate>;
  getKiosks: Array<Kiosk>;
  getKyc?: Maybe<StripeKyc>;
  getLocation: Location;
  getLocationPublic: Location;
  getMenu: Menu;
  getMenus: Array<Menu>;
  getMerchant?: Maybe<Merchant>;
  getMerchantLeadSummary?: Maybe<MerchantLeadSummary>;
  getMerchantPayments: PaymentList;
  getMerchantPublic?: Maybe<Merchant>;
  getMerchantQrCodesOrders: QrCodesOrderList;
  getMerchants?: Maybe<MerchantList>;
  getModifierSet: ModifierSet;
  getModifierSets: Array<ModifierSet>;
  getOfferConnection?: Maybe<OfferConnection>;
  getOfferConnections: Array<OfferConnection>;
  getOffers: Array<Offer>;
  getOffersUserProfile: OfferUserProfile;
  getOrder?: Maybe<OrderV0>;
  getOrderTypes: Array<OrderType>;
  getPayment?: Maybe<Payment>;
  getPayout: Payout;
  getPayoutTransactions: TransactionList;
  getPayouts: PayoutList;
  getPosConnection: PosConnection;
  getPosLocations: Array<PosLocation>;
  getPosOrderHeader: OrderHeader;
  getPosTableOrders?: Maybe<PosOrderList>;
  getPosTables: Array<PosTable>;
  getPreSignedUrl: Scalars['String'];
  getPriceBook: PriceBook;
  getPriceBooks: Array<PriceBook>;
  getProduct: Product;
  getProductInventory: Array<ProductInventory>;
  getProducts: Array<Product>;
  getQrCode: QrCode;
  getRecentPaymentsPos: Array<Payment>;
  getScreenLayout: ScreenLayout;
  getScreenLayouts: Array<ScreenLayout>;
  getStoreOrder?: Maybe<Order>;
  getStoreOrderByPayment?: Maybe<Order>;
  getStoreProduct: StoreProduct;
  getStoreProducts: Array<StoreProduct>;
  getStorefrontAppearance: StorefrontAppearance;
  getStorefrontConfiguration?: Maybe<StoreConfig>;
  getStorefrontConfigurationById?: Maybe<StorefrontConfiguration>;
  getStorefrontDetails: StorefrontStoreDetails;
  getStorefrontStrings: StorefrontStrings;
  getStorefronts: Array<StorefrontStoreSummary>;
  getTerminal: Terminal;
  getTerminalConfiguration: TerminalConfiguration;
  getTerminalConfigurations: Array<TerminalConfiguration>;
  getTerminals: Array<Terminal>;
  queryCollectionPoints: Array<CollectionPoint>;
};


export type QueryGetAllergenPreSignedUrlArgs = {
  fileSize: Scalars['Int'];
  mimeType: Scalars['String'];
  terminalConfigId: Scalars['String'];
};


export type QueryGetCompletedOrderArgs = {
  orderId: Scalars['String'];
};


export type QueryGetConfigurationOrderPreferencesArgs = {
  configurationId: Scalars['String'];
};


export type QueryGetConfigurationScheduledLayoutsArgs = {
  configurationId: Scalars['String'];
};


export type QueryGetDocumentVerificationArgs = {
  orderId: Scalars['String'];
  sessionId: Scalars['String'];
  terminalId: Scalars['String'];
};


export type QueryGetFacialAgeEstimationArgs = {
  imageBase64: Scalars['String'];
  orderId: Scalars['String'];
  terminalId: Scalars['String'];
};


export type QueryGetFeatureFlagsPublicArgs = {
  merchantId?: InputMaybe<Scalars['String']>;
};


export type QueryGetImagePreSignedUrlArgs = {
  fileName: Scalars['String'];
  fileSize: Scalars['Int'];
  mimeType: Scalars['String'];
};


export type QueryGetKdsConnectionArgs = {
  kdsConnectionId: Scalars['String'];
};


export type QueryGetKioskArgs = {
  kioskId: Scalars['String'];
};


export type QueryGetKioskAppearanceArgs = {
  kioskTemplateId: Scalars['String'];
};


export type QueryGetKioskCollectionSlipOptionsArgs = {
  kioskTemplateId: Scalars['String'];
};


export type QueryGetKioskProductInventoryArgs = {
  kioskId: Scalars['String'];
};


export type QueryGetKioskProductsArgs = {
  kioskId: Scalars['String'];
  query: ProductListQuery;
};


export type QueryGetKioskSecurityControlsArgs = {
  kioskTemplateId: Scalars['String'];
};


export type QueryGetKioskStringsArgs = {
  kioskTemplateId: Scalars['String'];
};


export type QueryGetKioskTemplateArgs = {
  terminalTemplateId: Scalars['String'];
};


export type QueryGetKioskTemplateDetailsArgs = {
  kioskTemplateId: Scalars['String'];
};


export type QueryGetKioskTemplateDetailsListArgs = {
  locationId?: InputMaybe<Scalars['String']>;
};


export type QueryGetKiosksArgs = {
  locationId: Scalars['String'];
};


export type QueryGetLocationArgs = {
  locationId: Scalars['String'];
};


export type QueryGetLocationPublicArgs = {
  locationId: Scalars['String'];
  merchantId: Scalars['String'];
};


export type QueryGetMenuArgs = {
  menuId: Scalars['String'];
};


export type QueryGetMerchantPaymentsArgs = {
  listQuery?: InputMaybe<PaymentListQuery>;
};


export type QueryGetMerchantPublicArgs = {
  merchantId: Scalars['String'];
};


export type QueryGetMerchantQrCodesOrdersArgs = {
  listQuery?: InputMaybe<QrCodesOrderListQuery>;
};


export type QueryGetMerchantsArgs = {
  listQuery?: InputMaybe<MerchantListQuery>;
};


export type QueryGetModifierSetArgs = {
  modifierSetId: Scalars['String'];
};


export type QueryGetModifierSetsArgs = {
  locationId: Scalars['String'];
};


export type QueryGetOfferConnectionArgs = {
  offerConnectionId: Scalars['String'];
};


export type QueryGetOffersArgs = {
  offerConnectionId: Scalars['String'];
};


export type QueryGetOffersUserProfileArgs = {
  offerConnectionId: Scalars['String'];
  userIdentifier: OfferUserIdentifier;
};


export type QueryGetOrderArgs = {
  merchantId: Scalars['String'];
  orderId: Scalars['String'];
};


export type QueryGetPaymentArgs = {
  id: Scalars['String'];
};


export type QueryGetPayoutArgs = {
  payoutId: Scalars['String'];
};


export type QueryGetPayoutTransactionsArgs = {
  listQuery?: InputMaybe<TransactionListQuery>;
  payoutId: Scalars['String'];
};


export type QueryGetPayoutsArgs = {
  listQuery?: InputMaybe<PayoutListQuery>;
};


export type QueryGetPosConnectionArgs = {
  posConnectionId: Scalars['String'];
};


export type QueryGetPosLocationsArgs = {
  posConnectionId: Scalars['String'];
};


export type QueryGetPosOrderHeaderArgs = {
  posLocationId: Scalars['String'];
  posOrderId: Scalars['String'];
  posSystem: PosSystem;
};


export type QueryGetPosTableOrdersArgs = {
  qr: Scalars['String'];
};


export type QueryGetPosTablesArgs = {
  locationId: Scalars['String'];
};


export type QueryGetPreSignedUrlArgs = {
  fileName: Scalars['String'];
  fileSize: Scalars['Int'];
  mimeType: Scalars['String'];
};


export type QueryGetPriceBookArgs = {
  priceBookId: Scalars['String'];
};


export type QueryGetProductArgs = {
  locationId: Scalars['String'];
  productId: Scalars['String'];
};


export type QueryGetProductInventoryArgs = {
  locationId: Scalars['String'];
};


export type QueryGetProductsArgs = {
  locationId: Scalars['String'];
};


export type QueryGetQrCodeArgs = {
  locationId: Scalars['String'];
  qrCodeId: Scalars['String'];
};


export type QueryGetRecentPaymentsPosArgs = {
  posLocationId: Scalars['String'];
  posSystem: PosSystem;
};


export type QueryGetScreenLayoutArgs = {
  screenLayoutId: Scalars['String'];
};


export type QueryGetScreenLayoutsArgs = {
  locationId?: InputMaybe<Scalars['String']>;
};


export type QueryGetStoreOrderArgs = {
  orderId: Scalars['String'];
};


export type QueryGetStoreOrderByPaymentArgs = {
  paymentId: Scalars['String'];
};


export type QueryGetStoreProductArgs = {
  locationId: Scalars['String'];
  merchantId: Scalars['String'];
  productId: Scalars['String'];
};


export type QueryGetStoreProductsArgs = {
  locationId: Scalars['String'];
  merchantId: Scalars['String'];
  selectedProducts: Array<SelectedProductIdInput>;
};


export type QueryGetStorefrontAppearanceArgs = {
  storefrontId: Scalars['String'];
};


export type QueryGetStorefrontConfigurationArgs = {
  merchantSlug: Scalars['String'];
  storefrontSlug: Scalars['String'];
};


export type QueryGetStorefrontConfigurationByIdArgs = {
  storefrontId: Scalars['String'];
};


export type QueryGetStorefrontDetailsArgs = {
  storefrontId: Scalars['String'];
};


export type QueryGetStorefrontStringsArgs = {
  storefrontId: Scalars['String'];
};


export type QueryGetTerminalArgs = {
  terminalId: Scalars['String'];
};


export type QueryGetTerminalConfigurationArgs = {
  terminalConfigurationId: Scalars['String'];
};


export type QueryGetTerminalsArgs = {
  locationId: Scalars['String'];
};


export type QueryQueryCollectionPointsArgs = {
  query?: InputMaybe<QueryCollectionPointsInput>;
};

export type QueryCollectionPointsInput = {
  ids?: InputMaybe<Array<Scalars['String']>>;
  locationId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CollectionPointType>;
};

export type ReceiptConfiguration = {
  __typename?: 'ReceiptConfiguration';
  additionalReceiptText?: Maybe<Scalars['String']>;
  receiptHeaderText?: Maybe<Scalars['String']>;
};

export type Redeemable = MoneyOffBasketRedeemable | PercentOffBasketRedeemable;

export type RedeemableInput = {
  type: Scalars['String'];
};

export type RedeemableLineItemInput = {
  amountDiscountTotal: Scalars['Int'];
  id: Scalars['String'];
  taxDiscountTotal: Scalars['Int'];
};

export type RedeemedOffer = {
  __typename?: 'RedeemedOffer';
  amountDiscountTotal: Scalars['Int'];
  id: Scalars['String'];
  taxDiscountTotal: Scalars['Int'];
};

export type RedeemedOfferInput = {
  id: Scalars['String'];
  lineItems: Array<RedeemableLineItemInput>;
  name: Scalars['String'];
  pointsUsed: Scalars['Int'];
  redeemable: Array<RedeemableInput>;
};

export type RefundInput = {
  amount?: InputMaybe<Scalars['Int']>;
  notes: Scalars['String'];
  paymentId: Scalars['String'];
};

export type RegisterUserForOnboarding = {
  __typename?: 'RegisterUserForOnboarding';
  success: Scalars['Boolean'];
};

export type RequestReceiptInput = {
  email?: InputMaybe<Scalars['String']>;
  paymentId: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type RequestReceiptResult = {
  __typename?: 'RequestReceiptResult';
  success: Scalars['Boolean'];
};

export type Schedule = {
  __typename?: 'Schedule';
  entries: Array<MenuScheduleEntry>;
  id: Scalars['String'];
};

export type ScheduleEntry = {
  __typename?: 'ScheduleEntry';
  day: Scalars['String'];
  endTime: Scalars['String'];
  screenLayouts: Array<ScreenLayout>;
  startTime: Scalars['String'];
};

export type ScheduledMenuInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type Screen = {
  __typename?: 'Screen';
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  products: Array<Product>;
  selectedProducts: Array<ScreenSelectedProducts>;
};

export type ScreenLayout = {
  __typename?: 'ScreenLayout';
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  location: Location;
  name: Scalars['String'];
  screens: Array<Screen>;
};

export type ScreenLayoutInput = {
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  locationId: Scalars['String'];
  name: Scalars['String'];
  screens: Array<ScreensInput>;
};

export type ScreenSelectedProducts = {
  __typename?: 'ScreenSelectedProducts';
  name: Scalars['String'];
  productId: Scalars['String'];
};

export type ScreenSelectedProductsInput = {
  name: Scalars['String'];
  productId: Scalars['String'];
};

export type ScreensInput = {
  id: Scalars['String'];
  image?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  selectedProducts: Array<ScreenSelectedProductsInput>;
};

export type SecretMetaData = {
  __typename?: 'SecretMetaData';
  createdAt: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type SelectedProductIdInput = {
  productId: Scalars['String'];
};

export type ServiceCharge = {
  __typename?: 'ServiceCharge';
  amount: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  taxItems: Array<TaxItem>;
};

export type ServiceChargeConfiguration = {
  __typename?: 'ServiceChargeConfiguration';
  enabled: Scalars['Boolean'];
  percentageHigh?: Maybe<Scalars['Float']>;
  percentageLow?: Maybe<Scalars['Float']>;
  percentageMedium?: Maybe<Scalars['Float']>;
};

export type ServiceChargeConfigurationInput = {
  enabled: Scalars['Boolean'];
  percentageHigh?: InputMaybe<Scalars['Float']>;
  percentageLow?: InputMaybe<Scalars['Float']>;
  percentageMedium?: InputMaybe<Scalars['Float']>;
};

export type ServicePayment = {
  __typename?: 'ServicePayment';
  amount: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  type: ServicePaymentType;
};

export type ServicePaymentInput = {
  amount: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  type: ServicePaymentType;
};

export type ServicePaymentProcessor = {
  __typename?: 'ServicePaymentProcessor';
  processor: Scalars['String'];
};

export type ServicePaymentProcessors = {
  __typename?: 'ServicePaymentProcessors';
  tablePay: ServicePaymentProcessor;
};

export enum ServicePaymentType {
  ServiceCharge = 'SERVICE_CHARGE',
  Tip = 'TIP'
}

export enum SortOrder {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING'
}

export enum Source {
  Kiosk = 'KIOSK',
  TablePay = 'TABLE_PAY'
}

export type Staff = {
  __typename?: 'Staff';
  name: Scalars['String'];
  posId: Scalars['String'];
};

export type StartPixPayment = {
  amount: Scalars['Int'];
  currency: Scalars['String'];
  id: Scalars['String'];
  merchantCode: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  source: Scalars['String'];
  urls: StartPixPaymentUrls;
};

export type StartPixPaymentUrls = {
  completion: Scalars['String'];
};

export type StoreCollectionPoint = {
  __typename?: 'StoreCollectionPoint';
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type StoreConfig = {
  __typename?: 'StoreConfig';
  acceptingOrders?: Maybe<Scalars['Boolean']>;
  activeScreens: Array<StoreScreen>;
  branding: Branding;
  currency: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  ends?: Maybe<Scalars['String']>;
  hours: StoreHours;
  locale: Scalars['String'];
  locationId: Scalars['String'];
  locationName: Scalars['String'];
  merchantId: Scalars['String'];
  merchantName: Scalars['String'];
  orderTypes: Array<StoreOrderType>;
  receipt?: Maybe<ReceiptConfiguration>;
  schedules: Array<StoreSchedule>;
  starts?: Maybe<Scalars['String']>;
  storeStatus: Scalars['String'];
  strings: StoreStrings;
  terminalId: Scalars['String'];
};

export type StoreHours = {
  __typename?: 'StoreHours';
  day: Scalars['String'];
  ends: Scalars['String'];
  isToday: Scalars['Boolean'];
  starts: Scalars['String'];
};

export type StoreOrderContactDetailsInput = {
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type StoreOrderInput = {
  consumerId: Scalars['String'];
  contactDetails?: InputMaybe<StoreOrderContactDetailsInput>;
  currency: Currency;
  customerOrderInfo: Array<CustomerOrderInfoInput>;
  id: Scalars['String'];
  locationId: Scalars['String'];
  merchantId: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  openedAt: Scalars['String'];
  orderLines: Array<OrderLineInput>;
  orderNumber?: InputMaybe<Scalars['String']>;
  serviceCharge?: InputMaybe<Array<ServicePaymentInput>>;
  terminalId: Scalars['String'];
};

export enum StoreOrderState {
  Accepted = 'ACCEPTED',
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type StoreOrderType = {
  __typename?: 'StoreOrderType';
  collectionPoints: Array<StoreCollectionPoint>;
  colour: Scalars['String'];
  customerPrompts: Array<OrderTypeCustomerPrompt>;
  description?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  notificationConfig: NotificationConfig;
  priceBookId: Scalars['String'];
};

export type StorePayment = {
  __typename?: 'StorePayment';
  amount: Scalars['Int'];
  cardDetails?: Maybe<PaymentCardDetails>;
  completedAt?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  currency: Currency;
  id: Scalars['String'];
  lineItems: Array<StorePaymentLineItem>;
  locationId: Scalars['String'];
  merchantId: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  orderId: Scalars['String'];
  orderPaymentIntention: OrderPaymentIntention;
  paymentMethod: PaymentMethod;
  processorDetails?: Maybe<ProcessorDetails>;
  processorId: Scalars['String'];
  servicePayments?: Maybe<Array<ServicePayment>>;
  source: Scalars['String'];
  state: PaymentState;
  transactionId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

export type StorePaymentLineItem = {
  __typename?: 'StorePaymentLineItem';
  amount: Scalars['Int'];
  externalVariantId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  quantity: Scalars['Int'];
  tax: Scalars['Int'];
  variantId: Scalars['String'];
};

export type StorePriceBook = {
  __typename?: 'StorePriceBook';
  default: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type StorePriceBookLine = {
  __typename?: 'StorePriceBookLine';
  amount: Scalars['Int'];
  priceBook: StorePriceBook;
  taxRate: StoreTaxRate;
};

export type StoreProduct = {
  __typename?: 'StoreProduct';
  brand?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  images: Array<StoreProductImage>;
  name: Scalars['String'];
  variants: Array<StoreProductVariant>;
};

export type StoreProductImage = {
  __typename?: 'StoreProductImage';
  url: Scalars['String'];
};

export type StoreProductModifier = {
  __typename?: 'StoreProductModifier';
  id: Scalars['String'];
  maxQuantity?: Maybe<Scalars['Int']>;
  minQuantity?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  variants: Array<StoreProductVariantWithoutModifiers>;
};

export type StoreProductVariant = {
  __typename?: 'StoreProductVariant';
  barcode?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  calories?: Maybe<Calories>;
  id: Scalars['String'];
  images: Array<StoreProductImage>;
  modifiers: Array<StoreProductModifier>;
  name: Scalars['String'];
  priceBookLines: Array<StorePriceBookLine>;
};

export type StoreProductVariantWithoutModifiers = {
  __typename?: 'StoreProductVariantWithoutModifiers';
  calories?: Maybe<Calories>;
  id: Scalars['String'];
  images: Array<StoreProductImage>;
  name: Scalars['String'];
  priceBookLines: Array<StorePriceBookLine>;
};

export type StoreReceiptConfiguration = {
  __typename?: 'StoreReceiptConfiguration';
  footerText?: Maybe<Scalars['String']>;
  headerText?: Maybe<Scalars['String']>;
};

export type StoreSchedule = {
  __typename?: 'StoreSchedule';
  day: Scalars['String'];
  endTime: Scalars['String'];
  id: Scalars['String'];
  startTime: Scalars['String'];
};

export type StoreScreen = {
  __typename?: 'StoreScreen';
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  products: Array<ProductId>;
};

export type StoreStrings = {
  __typename?: 'StoreStrings';
  globalMessageText?: Maybe<Scalars['String']>;
  orderConfirmationText?: Maybe<Scalars['String']>;
};

export type StoreTaxRate = {
  __typename?: 'StoreTaxRate';
  id: Scalars['String'];
  name: Scalars['String'];
  rate: Scalars['Float'];
};

export type StorefrontAppearance = {
  __typename?: 'StorefrontAppearance';
  bannerUrl?: Maybe<Scalars['String']>;
  brandingId?: Maybe<Scalars['String']>;
};

export type StorefrontAppearanceInput = {
  bannerUrl?: InputMaybe<Scalars['String']>;
  brandingId?: InputMaybe<Scalars['String']>;
};

export type StorefrontConfiguration = {
  __typename?: 'StorefrontConfiguration';
  appearance: StorefrontAppearance;
  details: StorefrontStoreDetails;
  orderPreferences: OrderPreferences;
  receiptStrings: StorefrontReceiptStrings;
  schedule: StorefrontSchedule;
  strings: StorefrontStrings;
  url: StorefrontSlugs;
};

export type StorefrontReceiptStrings = {
  __typename?: 'StorefrontReceiptStrings';
  additionalReceiptText?: Maybe<Scalars['String']>;
  receiptHeaderText?: Maybe<Scalars['String']>;
};

export type StorefrontReceiptStringsInput = {
  additionalReceiptText?: InputMaybe<Scalars['String']>;
  receiptHeaderText?: InputMaybe<Scalars['String']>;
};

export type StorefrontSchedule = {
  __typename?: 'StorefrontSchedule';
  day: Scalars['String'];
  endTime: Scalars['String'];
  screenLayoutId: Scalars['String'];
  startTime: Scalars['String'];
};

export type StorefrontSlugs = {
  __typename?: 'StorefrontSlugs';
  merchantSlug?: Maybe<Scalars['String']>;
  storefrontSlug?: Maybe<Scalars['String']>;
};

export type StorefrontSlugsInput = {
  merchantSlug?: InputMaybe<Scalars['String']>;
  storefrontSlug?: InputMaybe<Scalars['String']>;
};

export type StorefrontStoreDetails = {
  __typename?: 'StorefrontStoreDetails';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  kdsConnectionUrn?: Maybe<Scalars['String']>;
  locationId: Scalars['String'];
  storeName: Scalars['String'];
};

export type StorefrontStoreDetailsCreateInput = {
  description: Scalars['String'];
  kdsConnectionUrn?: InputMaybe<Scalars['String']>;
  locationId: Scalars['String'];
  storeName: Scalars['String'];
};

export type StorefrontStoreDetailsUpdateInput = {
  description?: InputMaybe<Scalars['String']>;
  kdsConnectionUrn?: InputMaybe<Scalars['String']>;
  storeName?: InputMaybe<Scalars['String']>;
};

export type StorefrontStoreSummary = {
  __typename?: 'StorefrontStoreSummary';
  id: Scalars['String'];
  locationId: Scalars['String'];
  locationName: Scalars['String'];
  storeName: Scalars['String'];
};

export type StorefrontStrings = {
  __typename?: 'StorefrontStrings';
  globalMessageText?: Maybe<Scalars['String']>;
};

export type StorefrontStringsInput = {
  globalMessageText?: InputMaybe<Scalars['String']>;
};

export type StripeAddress = {
  __typename?: 'StripeAddress';
  city: Scalars['String'];
  country: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
};

export type StripeAddressInput = {
  city: Scalars['String'];
  country: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
};

export type StripeBankAccount = {
  __typename?: 'StripeBankAccount';
  accountNumber: Scalars['String'];
  name: Scalars['String'];
  routingNumber: Scalars['String'];
};

export type StripeBankAccountInput = {
  accountNumber: Scalars['String'];
  name: Scalars['String'];
  routingNumber: Scalars['String'];
};

export type StripeBusinessProfile = {
  __typename?: 'StripeBusinessProfile';
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type StripeBusinessProfileInput = {
  name?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export enum StripeBusinessType {
  Company = 'COMPANY',
  Individual = 'INDIVIDUAL'
}

export type StripeCompany = {
  __typename?: 'StripeCompany';
  address?: Maybe<StripeAddress>;
  name?: Maybe<Scalars['String']>;
  people: Array<StripePerson>;
  phone?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
};

export type StripeCompanyInput = {
  address?: InputMaybe<StripeAddressInput>;
  name?: InputMaybe<Scalars['String']>;
  people: Array<StripePersonInput>;
  phone?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
};

export type StripeKyc = {
  __typename?: 'StripeKyc';
  businessProfile?: Maybe<StripeBusinessProfile>;
  businessType?: Maybe<StripeBusinessType>;
  company?: Maybe<StripeCompany>;
  individual?: Maybe<StripePerson>;
  payoutBankAccount?: Maybe<StripeBankAccount>;
};

export type StripeKycInput = {
  businessProfile?: InputMaybe<StripeBusinessProfileInput>;
  businessType?: InputMaybe<StripeBusinessType>;
  company?: InputMaybe<StripeCompanyInput>;
  individual?: InputMaybe<StripePersonInput>;
  payoutBankAccount?: InputMaybe<StripeBankAccountInput>;
};

export type StripePaymentIntent = {
  __typename?: 'StripePaymentIntent';
  clientSecret: Scalars['String'];
  id: Scalars['String'];
};

export type StripePaymentIntentInput = {
  amount: Scalars['Int'];
  currency: Currency;
  id?: InputMaybe<Scalars['String']>;
  locationId: Scalars['String'];
  merchantId: Scalars['String'];
  orderId: Scalars['String'];
};

export type StripePerson = {
  __typename?: 'StripePerson';
  address: StripeAddress;
  dateOfBirth: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  relationship?: Maybe<StripePersonRelationship>;
};

export type StripePersonInput = {
  address: StripeAddressInput;
  dateOfBirth: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  relationship?: InputMaybe<StripePersonRelationshipInput>;
};

export type StripePersonRelationship = {
  __typename?: 'StripePersonRelationship';
  director: Scalars['Boolean'];
  executive: Scalars['Boolean'];
  owner: Scalars['Boolean'];
  representative: Scalars['Boolean'];
  title: Scalars['String'];
};

export type StripePersonRelationshipInput = {
  director: Scalars['Boolean'];
  executive: Scalars['Boolean'];
  owner: Scalars['Boolean'];
  representative: Scalars['Boolean'];
  title: Scalars['String'];
};

export type SumUpCheckout = {
  __typename?: 'SumUpCheckout';
  amount: Scalars['Int'];
  checkoutReference: Scalars['String'];
  currency: Scalars['String'];
  id: Scalars['String'];
  merchantCode: Scalars['String'];
  status: Scalars['String'];
  transactionCode?: Maybe<Scalars['String']>;
};

export type SumUpPosConfig = {
  __typename?: 'SumUpPosConfig';
  merchantCode?: Maybe<Scalars['String']>;
  merchantId?: Maybe<Scalars['String']>;
};

export type SumUpPosProConfig = {
  __typename?: 'SumUpPosProConfig';
  storeId: Scalars['String'];
};

export type TaxBreakdown = {
  __typename?: 'TaxBreakdown';
  amount: Scalars['Int'];
  name: Scalars['String'];
  rate: Scalars['Float'];
};

export type TaxItem = {
  __typename?: 'TaxItem';
  amount: Scalars['Int'];
  percentage: Scalars['Float'];
};

export type TaxItemInput = {
  amount: Scalars['Int'];
  percentage: Scalars['Float'];
};

export type TaxRate = {
  __typename?: 'TaxRate';
  id: Scalars['String'];
  name: Scalars['String'];
  rate: Scalars['Float'];
};

export type TaxRateInput = {
  name: Scalars['String'];
  rate: Scalars['Float'];
};

export type Terminal = {
  __typename?: 'Terminal';
  configuration: TerminalConfiguration;
  id: Scalars['String'];
  layouts: Array<TerminalLayout>;
  location: Location;
  name: Scalars['String'];
  products: Array<Product>;
};

export type TerminalAppearance = {
  __typename?: 'TerminalAppearance';
  colors: TerminalAppearanceColors;
  images: TerminalAppearanceImages;
};

export type TerminalAppearanceColors = {
  __typename?: 'TerminalAppearanceColors';
  accent: Scalars['String'];
  background: Scalars['String'];
  primary: Scalars['String'];
  primaryText: Scalars['String'];
  text: Scalars['String'];
  warningText: Scalars['String'];
};

export type TerminalAppearanceColorsInput = {
  accent: Scalars['String'];
  background: Scalars['String'];
  primary: Scalars['String'];
  primaryText: Scalars['String'];
  text: Scalars['String'];
  warningText: Scalars['String'];
};

export type TerminalAppearanceImages = {
  __typename?: 'TerminalAppearanceImages';
  checkoutBannerUrl?: Maybe<Scalars['String']>;
  logoUrl: Scalars['String'];
  screenSaverImageUrls: Array<Scalars['String']>;
};

export type TerminalAppearanceImagesInput = {
  checkoutBannerUrl?: InputMaybe<Scalars['String']>;
  logoUrl: Scalars['String'];
  screenSaverImageUrls: Array<Scalars['String']>;
};

export type TerminalAppearanceInput = {
  colors: TerminalAppearanceColorsInput;
  images: TerminalAppearanceImagesInput;
};

export type TerminalConfiguration = {
  __typename?: 'TerminalConfiguration';
  activeScreenLayouts: Array<TerminalScreenLayout>;
  ageRestriction: AgeRestriction;
  allergenPdf?: Maybe<Scalars['String']>;
  allowedSumupMerchantIds: Array<Scalars['String']>;
  appearance: TerminalAppearance;
  customerOrderIdentifiers: Array<TerminalCustomerOrderIdentifier>;
  id: Scalars['String'];
  kdsConfig?: Maybe<TerminalKdsConfig>;
  localisation?: Maybe<TerminalLocalisationConfiguration>;
  name: Scalars['String'];
  offerConnections: Array<OfferConnection>;
  operatorMenuPin: Scalars['String'];
  orderReferenceFormat: OrderReferenceFormat;
  priceBooks?: Maybe<Array<TerminalPriceBook>>;
  receipt?: Maybe<TerminalReceiptConfiguration>;
  schedule: Array<TerminalSchedule>;
  screenLayouts: Array<ScreenLayout>;
  showAccessibilityOption: Scalars['Boolean'];
  showQrOnCompletedOrder: Scalars['Boolean'];
  showStartPrompt: Scalars['Boolean'];
  strings: TerminalStrings;
  upsellPriceBook?: Maybe<TerminalUpsellPriceBook>;
};

export type TerminalConfigurationInput = {
  activeScreenLayouts?: InputMaybe<Array<TerminalScreenLayoutInput>>;
  ageRestriction?: InputMaybe<AgeRestrictionInput>;
  allergenPdf?: InputMaybe<Scalars['String']>;
  allowedSumupMerchantIds: Array<Scalars['String']>;
  appearance: TerminalAppearanceInput;
  customerOrderIdentifiers?: InputMaybe<Array<TerminalCustomerOrderIdentifierInput>>;
  id?: InputMaybe<Scalars['String']>;
  kdsConfig?: InputMaybe<TerminalKdsConfigInput>;
  localisation?: InputMaybe<TerminalLocalisationConfigurationInput>;
  name: Scalars['String'];
  offerConnectionIds?: InputMaybe<Array<Scalars['String']>>;
  operatorMenuPin: Scalars['String'];
  orderReferenceFormat?: InputMaybe<OrderReferenceFormat>;
  priceBooks?: InputMaybe<Array<TerminalPriceBookInput>>;
  receipt?: InputMaybe<TerminalReceiptConfigurationInput>;
  showAccessibilityOption: Scalars['Boolean'];
  showQrOnCompletedOrder?: InputMaybe<Scalars['Boolean']>;
  showStartPrompt?: InputMaybe<Scalars['Boolean']>;
  strings: TerminalStringsInput;
  upsellPriceBook?: InputMaybe<TerminalUpsellPriceBookInput>;
};

export type TerminalCustomerOrderIdentifier = {
  __typename?: 'TerminalCustomerOrderIdentifier';
  isRequired: Scalars['Boolean'];
  priceBookIds: Array<Scalars['String']>;
  promptText: Scalars['String'];
};

export type TerminalCustomerOrderIdentifierInput = {
  isRequired: Scalars['Boolean'];
  priceBookIds: Array<Scalars['String']>;
  promptText: Scalars['String'];
};

export type TerminalInput = {
  configurationId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type TerminalKdsConfig = {
  __typename?: 'TerminalKdsConfig';
  connection: KdsConnection;
  locationId: Scalars['String'];
};

export type TerminalKdsConfigInput = {
  connectionId: Scalars['String'];
  locationId: Scalars['String'];
};

export type TerminalLayout = {
  __typename?: 'TerminalLayout';
  id: Scalars['String'];
  name: Scalars['String'];
  screens: Array<ProductCategory>;
};

export type TerminalLocalisationConfiguration = {
  __typename?: 'TerminalLocalisationConfiguration';
  currency: Currency;
  defaultLocale: Scalars['String'];
};

export type TerminalLocalisationConfigurationInput = {
  currency: Currency;
  defaultLocale: Scalars['String'];
};

export type TerminalPriceBook = {
  __typename?: 'TerminalPriceBook';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type TerminalPriceBookInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type TerminalReceiptConfiguration = {
  __typename?: 'TerminalReceiptConfiguration';
  additionalReceiptText?: Maybe<Scalars['String']>;
  print: Scalars['Boolean'];
  receiptHeaderText?: Maybe<Scalars['String']>;
  showPrices: Scalars['Boolean'];
};

export type TerminalReceiptConfigurationInput = {
  additionalReceiptText?: InputMaybe<Scalars['String']>;
  print: Scalars['Boolean'];
  receiptHeaderText?: InputMaybe<Scalars['String']>;
  showPrices: Scalars['Boolean'];
};

export type TerminalSchedule = {
  __typename?: 'TerminalSchedule';
  day: Scalars['String'];
  endTime: Scalars['String'];
  screenLayouts: Array<ScreenLayout>;
  startTime: Scalars['String'];
};

export type TerminalScheduleInput = {
  day: Scalars['String'];
  endTime: Scalars['String'];
  screenLayouts: Array<TerminalScheduleScreenLayoutInput>;
  startTime: Scalars['String'];
};

export type TerminalScheduleScreenLayoutInput = {
  id: Scalars['String'];
};

export type TerminalScreenLayout = {
  __typename?: 'TerminalScreenLayout';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type TerminalScreenLayoutInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type TerminalStrings = {
  __typename?: 'TerminalStrings';
  globalMessageText?: Maybe<Scalars['String']>;
  orderConfirmationText?: Maybe<Scalars['String']>;
};

export type TerminalStringsInput = {
  globalMessageText?: InputMaybe<Scalars['String']>;
  orderConfirmationText?: InputMaybe<Scalars['String']>;
};

export type TerminalUpsellPriceBook = {
  __typename?: 'TerminalUpsellPriceBook';
  modalText?: Maybe<Scalars['String']>;
  priceBookId: Scalars['String'];
};

export type TerminalUpsellPriceBookInput = {
  modalText?: InputMaybe<Scalars['String']>;
  priceBookId: Scalars['String'];
};

export type TickncookKdsConfig = {
  __typename?: 'TickncookKdsConfig';
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
};

export type Transaction = {
  __typename?: 'Transaction';
  amount: Scalars['Int'];
  availableOn: Scalars['String'];
  createdAt: Scalars['String'];
  currency: Currency;
  description?: Maybe<Scalars['String']>;
  exchangeRate?: Maybe<Scalars['String']>;
  fee?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  net?: Maybe<Scalars['Int']>;
  reportingCategory: Scalars['String'];
  status: Scalars['String'];
  type: Scalars['String'];
};

export type TransactionList = {
  __typename?: 'TransactionList';
  items?: Maybe<Array<Transaction>>;
  nextToken?: Maybe<Scalars['String']>;
  pageSize?: Maybe<Scalars['Int']>;
};

export type TransactionListQuery = {
  availableOnFrom?: InputMaybe<Scalars['String']>;
  availableOnTo?: InputMaybe<Scalars['String']>;
  createdAtFrom?: InputMaybe<Scalars['String']>;
  createdAtTo?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Currency>;
  nextToken?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type GetPublicLocationQueryVariables = Exact<{
  locationId: Scalars['String'];
  merchantId: Scalars['String'];
}>;


export type GetPublicLocationQuery = { __typename?: 'Query', getLocationPublic: { __typename?: 'Location', id: string, menuUrl?: string | null | undefined, serviceChargeConfiguration: { __typename?: 'ServiceChargeConfiguration', enabled: boolean, percentageHigh?: number | null | undefined, percentageLow?: number | null | undefined, percentageMedium?: number | null | undefined }, merchant: { __typename?: 'Merchant', businessName: string, countryCode: string, id: string } } };

export type FetchOrderPaymentsQueryVariables = Exact<{
  merchantId: Scalars['String'];
  orderId: Scalars['String'];
}>;


export type FetchOrderPaymentsQuery = { __typename?: 'Query', getOrder?: { __typename?: 'OrderV0', payments: Array<{ __typename?: 'Payment', amount: number, state: PaymentState, consumerName?: string | null | undefined, createdAt: string, currency: Currency, id: string, orderId?: string | null | undefined, parties?: number | null | undefined, cardDetails?: { __typename?: 'PaymentCardDetails', last4: string } | null | undefined, lineItems?: Array<{ __typename?: 'PaymentLineItem', name: string, amount: number, posId: string, quantity: number }> | null | undefined, servicePayment?: { __typename?: 'ServicePayment', amount: number, description?: string | null | undefined, type: ServicePaymentType } | null | undefined, processorMetadata?: { __typename?: 'PaymentProcessorMetadata', paymentIntentId?: string | null | undefined } | null | undefined }> } | null | undefined };

export type CheckPaymentStatusMutationVariables = Exact<{
  merchantId: Scalars['String'];
  paymentId: Scalars['String'];
}>;


export type CheckPaymentStatusMutation = { __typename?: 'Mutation', checkPaymentStatus: { __typename?: 'Payment', amount: number, state: PaymentState, consumerName?: string | null | undefined, createdAt: string, currency: Currency, id: string, orderId?: string | null | undefined, parties?: number | null | undefined, cardDetails?: { __typename?: 'PaymentCardDetails', last4: string } | null | undefined, lineItems?: Array<{ __typename?: 'PaymentLineItem', name: string, amount: number, posId: string, quantity: number }> | null | undefined, servicePayment?: { __typename?: 'ServicePayment', amount: number, description?: string | null | undefined, type: ServicePaymentType } | null | undefined, processorMetadata?: { __typename?: 'PaymentProcessorMetadata', paymentIntentId?: string | null | undefined } | null | undefined } };

export type StartSumUpOnlinePaymentMutationVariables = Exact<{
  merchantId: Scalars['String'];
  orderId: Scalars['String'];
  payment: PaymentInput;
  redirectUrl: Scalars['String'];
}>;


export type StartSumUpOnlinePaymentMutation = { __typename?: 'Mutation', startPayment: { __typename?: 'Payment', id: string, orderId?: string | null | undefined, currency: Currency, amount: number, paymentMethod?: PaymentMethod | null | undefined, processorReference?: string | null | undefined, consumerName?: string | null | undefined, notes?: string | null | undefined, createdAt: string, parties?: number | null | undefined, source: Source, state: PaymentState, processorMetadata?: { __typename?: 'PaymentProcessorMetadata', paymentIntentId?: string | null | undefined, merchantId?: string | null | undefined, foreignTransactionId?: string | null | undefined } | null | undefined, orderPaymentIntention?: { __typename?: 'OrderPaymentIntention', orderPaymentType: OrderPaymentType, partySize?: number | null | undefined } | null | undefined } };

export type GetOrderQueryVariables = Exact<{
  merchantId: Scalars['String'];
  orderId: Scalars['String'];
}>;


export type GetOrderQuery = { __typename?: 'Query', getOrder?: { __typename?: 'OrderV0', amount: number, covers?: number | null | undefined, currency: Currency, id: string, notes?: string | null | undefined, openedAt: string, posId?: string | null | undefined, posReference?: string | null | undefined, posTableName?: string | null | undefined, tax: number, hasDiscounts?: boolean | null | undefined, lineItems: Array<{ __typename?: 'LineItem', amount: number, name: string, notes?: string | null | undefined, posId?: string | null | undefined, quantity: number, childItems: Array<{ __typename?: 'ChildItem', amount: number, name: string, quantity: number }>, taxItems: Array<{ __typename?: 'TaxItem', amount: number, percentage: number }> }>, orderPaymentIntention?: { __typename?: 'OrderPaymentIntention', orderPaymentType: OrderPaymentType, partySize?: number | null | undefined } | null | undefined, payments: Array<{ __typename?: 'Payment', amount: number, consumerName?: string | null | undefined, createdAt: string, currency: Currency, id: string, orderId?: string | null | undefined, parties?: number | null | undefined, lineItems?: Array<{ __typename?: 'PaymentLineItem', amount: number, posId: string, quantity: number }> | null | undefined, servicePayment?: { __typename?: 'ServicePayment', amount: number, description?: string | null | undefined, type: ServicePaymentType } | null | undefined }>, serviceCharge?: { __typename?: 'ServiceCharge', amount: number, description?: string | null | undefined, taxItems: Array<{ __typename?: 'TaxItem', amount: number, percentage: number }> } | null | undefined, staff?: { __typename?: 'Staff', name: string, posId: string } | null | undefined } | null | undefined };

export type GetOrderAndLocationQueryVariables = Exact<{
  merchantId: Scalars['String'];
  orderId: Scalars['String'];
  locationId: Scalars['String'];
}>;


export type GetOrderAndLocationQuery = { __typename?: 'Query', getOrder?: { __typename?: 'OrderV0', amount: number, completed: boolean, covers?: number | null | undefined, currency: Currency, id: string, notes?: string | null | undefined, openedAt: string, posId?: string | null | undefined, posReference?: string | null | undefined, posTableName?: string | null | undefined, tax: number, hasDiscounts?: boolean | null | undefined, lineItems: Array<{ __typename?: 'LineItem', amount: number, name: string, notes?: string | null | undefined, posId?: string | null | undefined, quantity: number, childItems: Array<{ __typename?: 'ChildItem', amount: number, name: string, quantity: number }>, taxItems: Array<{ __typename?: 'TaxItem', amount: number, percentage: number }> }>, orderPaymentIntention?: { __typename?: 'OrderPaymentIntention', orderPaymentType: OrderPaymentType, partySize?: number | null | undefined } | null | undefined, payments: Array<{ __typename?: 'Payment', amount: number, state: PaymentState, consumerName?: string | null | undefined, createdAt: string, currency: Currency, id: string, orderId?: string | null | undefined, parties?: number | null | undefined, cardDetails?: { __typename?: 'PaymentCardDetails', last4: string } | null | undefined, lineItems?: Array<{ __typename?: 'PaymentLineItem', name: string, amount: number, posId: string, quantity: number }> | null | undefined, servicePayment?: { __typename?: 'ServicePayment', amount: number, description?: string | null | undefined, type: ServicePaymentType } | null | undefined, processorMetadata?: { __typename?: 'PaymentProcessorMetadata', paymentIntentId?: string | null | undefined } | null | undefined }>, serviceCharge?: { __typename?: 'ServiceCharge', amount: number, description?: string | null | undefined, taxItems: Array<{ __typename?: 'TaxItem', amount: number, percentage: number }> } | null | undefined, staff?: { __typename?: 'Staff', name: string, posId: string } | null | undefined, posPayments?: Array<{ __typename?: 'PosPayment', amount: number, paymentMethod: string, external: boolean }> | null | undefined } | null | undefined, getLocationPublic: { __typename?: 'Location', id: string, menuUrl?: string | null | undefined, name: string, serviceChargeConfiguration: { __typename?: 'ServiceChargeConfiguration', enabled: boolean, percentageHigh?: number | null | undefined, percentageLow?: number | null | undefined, percentageMedium?: number | null | undefined }, merchant: { __typename?: 'Merchant', businessName: string, countryCode: string, id: string, status: { __typename?: 'MerchantStatus', paymentsEnabled: boolean } } } };

export type PaymentSetupMutationVariables = Exact<{
  merchantId: Scalars['String'];
  orderId: Scalars['String'];
  paymentProcessorData?: InputMaybe<PaymentProcessorInput>;
  payment: PaymentInput;
}>;


export type PaymentSetupMutation = { __typename?: 'Mutation', putPaymentSetup: { __typename?: 'PaymentSetup', stripePaymentIntent?: { __typename?: 'StripePaymentIntent', clientSecret: string, id: string } | null | undefined } };

export type CreatePaymentMutationVariables = Exact<{
  merchantId: Scalars['String'];
  orderId: Scalars['String'];
  paymentProcessorData: PaymentProcessorInput;
  payment: PaymentInput;
}>;


export type CreatePaymentMutation = { __typename?: 'Mutation', createPayment: { __typename?: 'Payment', amount: number, consumerName?: string | null | undefined, id: string, cardDetails?: { __typename?: 'PaymentCardDetails', brand: string, last4: string, wallet?: PaymentCardWallet | null | undefined } | null | undefined } };

export type GetPosTableOrdersQueryVariables = Exact<{
  qr: Scalars['String'];
}>;


export type GetPosTableOrdersQuery = { __typename?: 'Query', getPosTableOrders?: { __typename?: 'PosOrderList', qrCode?: { __typename?: 'QrCode', tableName: string, redirectToLinks?: boolean | null | undefined } | null | undefined, location: { __typename?: 'Location', id: string, menuUrl?: string | null | undefined, name: string, merchant: { __typename?: 'Merchant', businessName: string, id: string, status: { __typename?: 'MerchantStatus', paymentsEnabled: boolean }, locations: Array<{ __typename?: 'Location', id: string, menuUrl?: string | null | undefined, name: string }>, servicePaymentProcessors: { __typename?: 'ServicePaymentProcessors', tablePay: { __typename?: 'ServicePaymentProcessor', processor: string } } }, serviceChargeConfiguration: { __typename?: 'ServiceChargeConfiguration', enabled: boolean, percentageHigh?: number | null | undefined, percentageLow?: number | null | undefined, percentageMedium?: number | null | undefined } }, orders: Array<{ __typename?: 'OrderHeader', id?: string | null | undefined }> } | null | undefined };

export type GetPosOrderHeaderQueryVariables = Exact<{
  posLocationId: Scalars['String'];
  posOrderId: Scalars['String'];
  posSystem: PosSystem;
}>;


export type GetPosOrderHeaderQuery = { __typename?: 'Query', getPosOrderHeader: { __typename?: 'OrderHeader', id?: string | null | undefined, locationId: string, merchantId: string } };

export type GetOrderForReceiptQueryVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type GetOrderForReceiptQuery = { __typename?: 'Query', getStoreOrder?: { __typename?: 'Order', id: string, merchantId: string, orderRef: string, amount: number, tax: number, currency: Currency, notes?: string | null | undefined, state: StoreOrderState, taxBreakdown: Array<{ __typename?: 'TaxBreakdown', name: string, amount: number, rate: number }>, customerOrderInfo: Array<{ __typename?: 'CustomerOrderInfo', orderType: { __typename?: 'CustomerOrderInfoOrderType', id: string, name: string }, customerProvidedReference: Array<{ __typename?: 'KeyValue', key: string, value: string }>, collectionPoint?: { __typename?: 'CustomerOrderInfoCollectionPoint', id: string, name: string } | null | undefined }>, lineItems: Array<{ __typename?: 'OrderLineItem', name: string, quantity: number, amount: number, orderTypeId: string, modifiers: Array<{ __typename?: 'OrderModifierItem', name: string, amount: number, quantity: number }> }>, payments: Array<{ __typename?: 'StorePayment', id: string, amount: number, currency: Currency, paymentMethod: PaymentMethod, cardDetails?: { __typename?: 'PaymentCardDetails', last4: string } | null | undefined, processorDetails?: { __typename?: 'ProcessorDetails', transactionCode?: string | null | undefined } | null | undefined }>, receiptConfiguration?: { __typename?: 'StoreReceiptConfiguration', headerText?: string | null | undefined, footerText?: string | null | undefined } | null | undefined } | null | undefined };

export type GetOapOrderForReceiptQueryVariables = Exact<{
  orderId: Scalars['String'];
}>;


export type GetOapOrderForReceiptQuery = { __typename?: 'Query', getCompletedOrder?: { __typename?: 'OrderV0', amount: number, lastRetrievedAt?: string | null | undefined, currency: Currency, notes?: string | null | undefined, tax: number, state: OrderState, posReference?: string | null | undefined, fulfilmentDetails: Array<{ __typename?: 'FulfilmentDetail', id: string, fulfilmentType: FulfilmentType, reference?: string | null | undefined, priceBook: { __typename?: 'FulfilmentDetailPriceBook', id: string, name: string } }>, lineItems: Array<{ __typename?: 'LineItem', amount: number, name: string, notes?: string | null | undefined, quantity: number, fulfilmentDetailId?: string | null | undefined, amountDiscountTotal?: number | null | undefined, childItems: Array<{ __typename?: 'ChildItem', amount: number, name: string, quantity: number, priceBookLine?: { __typename?: 'OrderLinePriceBookLine', amount: number, priceBook: { __typename?: 'OrderLinePriceBook', id: string, name: string } } | null | undefined }>, taxItems: Array<{ __typename?: 'TaxItem', amount: number, percentage: number }>, priceBookLine?: { __typename?: 'OrderLinePriceBookLine', priceBook: { __typename?: 'OrderLinePriceBook', id: string, name: string } } | null | undefined }>, payments: Array<{ __typename?: 'Payment', id: string, amount: number, consumerName?: string | null | undefined, processorReference?: string | null | undefined, cardDetails?: { __typename?: 'PaymentCardDetails', last4: string } | null | undefined, fiscalization?: { __typename?: 'FiscalizationResult', receiptAdditions?: { __typename?: 'FiscalizationReceiptAdditions', digital: { __typename?: 'FiscalizationReceiptText', header?: string | null | undefined, footer?: string | null | undefined } } | null | undefined } | null | undefined }>, receiptConfiguration?: { __typename?: 'ReceiptConfiguration', additionalReceiptText?: string | null | undefined, receiptHeaderText?: string | null | undefined } | null | undefined, serviceCharge?: { __typename?: 'ServiceCharge', amount: number, description?: string | null | undefined } | null | undefined } | null | undefined };


export const GetPublicLocationDocument = `
    query GetPublicLocation($locationId: String!, $merchantId: String!) {
  getLocationPublic(locationId: $locationId, merchantId: $merchantId) {
    serviceChargeConfiguration {
      enabled
      percentageHigh
      percentageLow
      percentageMedium
    }
    id
    menuUrl
    merchant {
      businessName
      countryCode
      id
    }
  }
}
    `;
export const useGetPublicLocationQuery = <
      TData = GetPublicLocationQuery,
      TError = ApiError[]
    >(
      variables: GetPublicLocationQueryVariables,
      options?: UseQueryOptions<GetPublicLocationQuery, TError, TData>
    ) =>
    useQuery<GetPublicLocationQuery, TError, TData>(
      ['GetPublicLocation', variables],
      oapFetcher<GetPublicLocationQuery, GetPublicLocationQueryVariables>(GetPublicLocationDocument, variables),
      options
    );
export const FetchOrderPaymentsDocument = `
    query fetchOrderPayments($merchantId: String!, $orderId: String!) {
  getOrder(merchantId: $merchantId, orderId: $orderId) {
    payments {
      amount
      state
      consumerName
      createdAt
      currency
      id
      cardDetails {
        last4
      }
      lineItems {
        name
        amount
        posId
        quantity
      }
      orderId
      parties
      servicePayment {
        amount
        description
        type
      }
      processorMetadata {
        paymentIntentId
      }
    }
  }
}
    `;
export const useFetchOrderPaymentsQuery = <
      TData = FetchOrderPaymentsQuery,
      TError = ApiError[]
    >(
      variables: FetchOrderPaymentsQueryVariables,
      options?: UseQueryOptions<FetchOrderPaymentsQuery, TError, TData>
    ) =>
    useQuery<FetchOrderPaymentsQuery, TError, TData>(
      ['fetchOrderPayments', variables],
      oapFetcher<FetchOrderPaymentsQuery, FetchOrderPaymentsQueryVariables>(FetchOrderPaymentsDocument, variables),
      options
    );
export const CheckPaymentStatusDocument = `
    mutation checkPaymentStatus($merchantId: String!, $paymentId: String!) {
  checkPaymentStatus(merchantId: $merchantId, paymentId: $paymentId) {
    amount
    state
    consumerName
    createdAt
    currency
    id
    cardDetails {
      last4
    }
    lineItems {
      name
      amount
      posId
      quantity
    }
    orderId
    parties
    servicePayment {
      amount
      description
      type
    }
    processorMetadata {
      paymentIntentId
    }
  }
}
    `;
export const useCheckPaymentStatusMutation = <
      TError = ApiError[],
      TContext = unknown
    >(options?: UseMutationOptions<CheckPaymentStatusMutation, TError, CheckPaymentStatusMutationVariables, TContext>) =>
    useMutation<CheckPaymentStatusMutation, TError, CheckPaymentStatusMutationVariables, TContext>(
      'checkPaymentStatus',
      (variables?: CheckPaymentStatusMutationVariables) => oapFetcher<CheckPaymentStatusMutation, CheckPaymentStatusMutationVariables>(CheckPaymentStatusDocument, variables)(),
      options
    );
export const StartSumUpOnlinePaymentDocument = `
    mutation StartSumUpOnlinePayment($merchantId: String!, $orderId: String!, $payment: PaymentInput!, $redirectUrl: String!) {
  startPayment(
    merchantId: $merchantId
    orderId: $orderId
    payment: $payment
    redirectUrl: $redirectUrl
  ) {
    id
    orderId
    currency
    amount
    paymentMethod
    processorReference
    processorMetadata {
      paymentIntentId
      merchantId
      foreignTransactionId
    }
    consumerName
    notes
    createdAt
    parties
    source
    state
    orderPaymentIntention {
      orderPaymentType
      partySize
    }
  }
}
    `;
export const useStartSumUpOnlinePaymentMutation = <
      TError = ApiError[],
      TContext = unknown
    >(options?: UseMutationOptions<StartSumUpOnlinePaymentMutation, TError, StartSumUpOnlinePaymentMutationVariables, TContext>) =>
    useMutation<StartSumUpOnlinePaymentMutation, TError, StartSumUpOnlinePaymentMutationVariables, TContext>(
      'StartSumUpOnlinePayment',
      (variables?: StartSumUpOnlinePaymentMutationVariables) => oapFetcher<StartSumUpOnlinePaymentMutation, StartSumUpOnlinePaymentMutationVariables>(StartSumUpOnlinePaymentDocument, variables)(),
      options
    );
export const GetOrderDocument = `
    query GetOrder($merchantId: String!, $orderId: String!) {
  getOrder(merchantId: $merchantId, orderId: $orderId) {
    amount
    covers
    currency
    id
    lineItems {
      amount
      childItems {
        amount
        name
        quantity
      }
      name
      notes
      posId
      quantity
      taxItems {
        amount
        percentage
      }
    }
    notes
    openedAt
    orderPaymentIntention {
      orderPaymentType
      partySize
    }
    payments {
      amount
      consumerName
      createdAt
      currency
      id
      lineItems {
        amount
        posId
        quantity
      }
      orderId
      parties
      servicePayment {
        amount
        description
        type
      }
    }
    posId
    posReference
    posTableName
    serviceCharge {
      amount
      description
      taxItems {
        amount
        percentage
      }
    }
    staff {
      name
      posId
    }
    tax
    hasDiscounts
  }
}
    `;
export const useGetOrderQuery = <
      TData = GetOrderQuery,
      TError = ApiError[]
    >(
      variables: GetOrderQueryVariables,
      options?: UseQueryOptions<GetOrderQuery, TError, TData>
    ) =>
    useQuery<GetOrderQuery, TError, TData>(
      ['GetOrder', variables],
      oapFetcher<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, variables),
      options
    );
export const GetOrderAndLocationDocument = `
    query GetOrderAndLocation($merchantId: String!, $orderId: String!, $locationId: String!) {
  getOrder(merchantId: $merchantId, orderId: $orderId) {
    amount
    completed
    covers
    currency
    id
    lineItems {
      amount
      childItems {
        amount
        name
        quantity
      }
      name
      notes
      posId
      quantity
      taxItems {
        amount
        percentage
      }
    }
    notes
    openedAt
    orderPaymentIntention {
      orderPaymentType
      partySize
    }
    payments {
      amount
      state
      consumerName
      createdAt
      currency
      id
      cardDetails {
        last4
      }
      lineItems {
        name
        amount
        posId
        quantity
      }
      orderId
      parties
      servicePayment {
        amount
        description
        type
      }
      processorMetadata {
        paymentIntentId
      }
    }
    posId
    posReference
    posTableName
    serviceCharge {
      amount
      description
      taxItems {
        amount
        percentage
      }
    }
    staff {
      name
      posId
    }
    tax
    posPayments {
      amount
      paymentMethod
      external
    }
    hasDiscounts
  }
  getLocationPublic(locationId: $locationId, merchantId: $merchantId) {
    serviceChargeConfiguration {
      enabled
      percentageHigh
      percentageLow
      percentageMedium
    }
    id
    menuUrl
    merchant {
      businessName
      countryCode
      id
      status {
        paymentsEnabled
      }
    }
    name
  }
}
    `;
export const useGetOrderAndLocationQuery = <
      TData = GetOrderAndLocationQuery,
      TError = ApiError[]
    >(
      variables: GetOrderAndLocationQueryVariables,
      options?: UseQueryOptions<GetOrderAndLocationQuery, TError, TData>
    ) =>
    useQuery<GetOrderAndLocationQuery, TError, TData>(
      ['GetOrderAndLocation', variables],
      oapFetcher<GetOrderAndLocationQuery, GetOrderAndLocationQueryVariables>(GetOrderAndLocationDocument, variables),
      options
    );
export const PaymentSetupDocument = `
    mutation PaymentSetup($merchantId: String!, $orderId: String!, $paymentProcessorData: PaymentProcessorInput, $payment: PaymentInput!) {
  putPaymentSetup(
    merchantId: $merchantId
    orderId: $orderId
    payment: $payment
    paymentProcessorData: $paymentProcessorData
  ) {
    stripePaymentIntent {
      clientSecret
      id
    }
  }
}
    `;
export const usePaymentSetupMutation = <
      TError = ApiError[],
      TContext = unknown
    >(options?: UseMutationOptions<PaymentSetupMutation, TError, PaymentSetupMutationVariables, TContext>) =>
    useMutation<PaymentSetupMutation, TError, PaymentSetupMutationVariables, TContext>(
      'PaymentSetup',
      (variables?: PaymentSetupMutationVariables) => oapFetcher<PaymentSetupMutation, PaymentSetupMutationVariables>(PaymentSetupDocument, variables)(),
      options
    );
export const CreatePaymentDocument = `
    mutation CreatePayment($merchantId: String!, $orderId: String!, $paymentProcessorData: PaymentProcessorInput!, $payment: PaymentInput!) {
  createPayment(
    merchantId: $merchantId
    orderId: $orderId
    payment: $payment
    paymentProcessorData: $paymentProcessorData
  ) {
    amount
    cardDetails {
      brand
      last4
      wallet
    }
    consumerName
    id
  }
}
    `;
export const useCreatePaymentMutation = <
      TError = ApiError[],
      TContext = unknown
    >(options?: UseMutationOptions<CreatePaymentMutation, TError, CreatePaymentMutationVariables, TContext>) =>
    useMutation<CreatePaymentMutation, TError, CreatePaymentMutationVariables, TContext>(
      'CreatePayment',
      (variables?: CreatePaymentMutationVariables) => oapFetcher<CreatePaymentMutation, CreatePaymentMutationVariables>(CreatePaymentDocument, variables)(),
      options
    );
export const GetPosTableOrdersDocument = `
    query GetPosTableOrders($qr: String!) {
  getPosTableOrders(qr: $qr) {
    qrCode {
      tableName
      redirectToLinks
    }
    location {
      id
      menuUrl
      name
      merchant {
        businessName
        id
        status {
          paymentsEnabled
        }
        locations {
          id
          menuUrl
          name
        }
        servicePaymentProcessors {
          tablePay {
            processor
          }
        }
      }
      serviceChargeConfiguration {
        enabled
        percentageHigh
        percentageLow
        percentageMedium
      }
    }
    orders {
      id
    }
  }
}
    `;
export const useGetPosTableOrdersQuery = <
      TData = GetPosTableOrdersQuery,
      TError = ApiError[]
    >(
      variables: GetPosTableOrdersQueryVariables,
      options?: UseQueryOptions<GetPosTableOrdersQuery, TError, TData>
    ) =>
    useQuery<GetPosTableOrdersQuery, TError, TData>(
      ['GetPosTableOrders', variables],
      oapFetcher<GetPosTableOrdersQuery, GetPosTableOrdersQueryVariables>(GetPosTableOrdersDocument, variables),
      options
    );
export const GetPosOrderHeaderDocument = `
    query GetPosOrderHeader($posLocationId: String!, $posOrderId: String!, $posSystem: PosSystem!) {
  getPosOrderHeader(
    posLocationId: $posLocationId
    posOrderId: $posOrderId
    posSystem: $posSystem
  ) {
    id
    locationId
    merchantId
  }
}
    `;
export const useGetPosOrderHeaderQuery = <
      TData = GetPosOrderHeaderQuery,
      TError = ApiError[]
    >(
      variables: GetPosOrderHeaderQueryVariables,
      options?: UseQueryOptions<GetPosOrderHeaderQuery, TError, TData>
    ) =>
    useQuery<GetPosOrderHeaderQuery, TError, TData>(
      ['GetPosOrderHeader', variables],
      oapFetcher<GetPosOrderHeaderQuery, GetPosOrderHeaderQueryVariables>(GetPosOrderHeaderDocument, variables),
      options
    );
export const GetOrderForReceiptDocument = `
    query GetOrderForReceipt($orderId: String!) {
  getStoreOrder(orderId: $orderId) {
    id
    merchantId
    orderRef
    amount
    tax
    currency
    taxBreakdown {
      name
      amount
      rate
    }
    notes
    customerOrderInfo {
      orderType {
        id
        name
      }
      customerProvidedReference {
        key
        value
      }
      collectionPoint {
        id
        name
      }
    }
    lineItems {
      name
      quantity
      amount
      orderTypeId
      modifiers {
        name
        amount
        quantity
      }
    }
    payments {
      id
      cardDetails {
        last4
      }
      processorDetails {
        transactionCode
      }
      amount
      currency
      paymentMethod
    }
    state
    receiptConfiguration {
      headerText
      footerText
    }
  }
}
    `;
export const useGetOrderForReceiptQuery = <
      TData = GetOrderForReceiptQuery,
      TError = ApiError[]
    >(
      variables: GetOrderForReceiptQueryVariables,
      options?: UseQueryOptions<GetOrderForReceiptQuery, TError, TData>
    ) =>
    useQuery<GetOrderForReceiptQuery, TError, TData>(
      ['GetOrderForReceipt', variables],
      oapFetcher<GetOrderForReceiptQuery, GetOrderForReceiptQueryVariables>(GetOrderForReceiptDocument, variables),
      options
    );
export const GetOapOrderForReceiptDocument = `
    query GetOapOrderForReceipt($orderId: String!) {
  getCompletedOrder(orderId: $orderId) {
    amount
    lastRetrievedAt
    currency
    fulfilmentDetails {
      id
      fulfilmentType
      priceBook {
        id
        name
      }
      reference
    }
    lineItems {
      amount
      childItems {
        amount
        name
        priceBookLine {
          amount
          priceBook {
            id
            name
          }
        }
        quantity
      }
      name
      notes
      quantity
      taxItems {
        amount
        percentage
      }
      priceBookLine {
        priceBook {
          id
          name
        }
      }
      fulfilmentDetailId
      amountDiscountTotal
    }
    notes
    tax
    state
    posReference
    payments {
      id
      amount
      cardDetails {
        last4
      }
      consumerName
      processorReference
      fiscalization {
        receiptAdditions {
          digital {
            header
            footer
          }
        }
      }
    }
    receiptConfiguration {
      additionalReceiptText
      receiptHeaderText
    }
    serviceCharge {
      amount
      description
    }
  }
}
    `;
export const useGetOapOrderForReceiptQuery = <
      TData = GetOapOrderForReceiptQuery,
      TError = ApiError[]
    >(
      variables: GetOapOrderForReceiptQueryVariables,
      options?: UseQueryOptions<GetOapOrderForReceiptQuery, TError, TData>
    ) =>
    useQuery<GetOapOrderForReceiptQuery, TError, TData>(
      ['GetOapOrderForReceipt', variables],
      oapFetcher<GetOapOrderForReceiptQuery, GetOapOrderForReceiptQueryVariables>(GetOapOrderForReceiptDocument, variables),
      options
    );
const supay = graphql.link('https://api.staging.supay.co.uk/graphql')

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetPublicLocationQuerySupay((req, res, ctx) => {
 *   const { locationId, merchantId } = req.variables;
 *   return res(
 *     ctx.data({ getLocationPublic })
 *   )
 * })
 */
export const mockGetPublicLocationQuerySupay = (resolver: ResponseResolver<GraphQLRequest<GetPublicLocationQueryVariables>, GraphQLContext<GetPublicLocationQuery>, any>) =>
  supay.query<GetPublicLocationQuery, GetPublicLocationQueryVariables>(
    'GetPublicLocation',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockFetchOrderPaymentsQuerySupay((req, res, ctx) => {
 *   const { merchantId, orderId } = req.variables;
 *   return res(
 *     ctx.data({ getOrder })
 *   )
 * })
 */
export const mockFetchOrderPaymentsQuerySupay = (resolver: ResponseResolver<GraphQLRequest<FetchOrderPaymentsQueryVariables>, GraphQLContext<FetchOrderPaymentsQuery>, any>) =>
  supay.query<FetchOrderPaymentsQuery, FetchOrderPaymentsQueryVariables>(
    'fetchOrderPayments',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCheckPaymentStatusMutationSupay((req, res, ctx) => {
 *   const { merchantId, paymentId } = req.variables;
 *   return res(
 *     ctx.data({ checkPaymentStatus })
 *   )
 * })
 */
export const mockCheckPaymentStatusMutationSupay = (resolver: ResponseResolver<GraphQLRequest<CheckPaymentStatusMutationVariables>, GraphQLContext<CheckPaymentStatusMutation>, any>) =>
  supay.mutation<CheckPaymentStatusMutation, CheckPaymentStatusMutationVariables>(
    'checkPaymentStatus',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStartSumUpOnlinePaymentMutationSupay((req, res, ctx) => {
 *   const { merchantId, orderId, payment, redirectUrl } = req.variables;
 *   return res(
 *     ctx.data({ startPayment })
 *   )
 * })
 */
export const mockStartSumUpOnlinePaymentMutationSupay = (resolver: ResponseResolver<GraphQLRequest<StartSumUpOnlinePaymentMutationVariables>, GraphQLContext<StartSumUpOnlinePaymentMutation>, any>) =>
  supay.mutation<StartSumUpOnlinePaymentMutation, StartSumUpOnlinePaymentMutationVariables>(
    'StartSumUpOnlinePayment',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetOrderQuerySupay((req, res, ctx) => {
 *   const { merchantId, orderId } = req.variables;
 *   return res(
 *     ctx.data({ getOrder })
 *   )
 * })
 */
export const mockGetOrderQuerySupay = (resolver: ResponseResolver<GraphQLRequest<GetOrderQueryVariables>, GraphQLContext<GetOrderQuery>, any>) =>
  supay.query<GetOrderQuery, GetOrderQueryVariables>(
    'GetOrder',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetOrderAndLocationQuerySupay((req, res, ctx) => {
 *   const { merchantId, orderId, locationId } = req.variables;
 *   return res(
 *     ctx.data({ getOrder, getLocationPublic })
 *   )
 * })
 */
export const mockGetOrderAndLocationQuerySupay = (resolver: ResponseResolver<GraphQLRequest<GetOrderAndLocationQueryVariables>, GraphQLContext<GetOrderAndLocationQuery>, any>) =>
  supay.query<GetOrderAndLocationQuery, GetOrderAndLocationQueryVariables>(
    'GetOrderAndLocation',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPaymentSetupMutationSupay((req, res, ctx) => {
 *   const { merchantId, orderId, paymentProcessorData, payment } = req.variables;
 *   return res(
 *     ctx.data({ putPaymentSetup })
 *   )
 * })
 */
export const mockPaymentSetupMutationSupay = (resolver: ResponseResolver<GraphQLRequest<PaymentSetupMutationVariables>, GraphQLContext<PaymentSetupMutation>, any>) =>
  supay.mutation<PaymentSetupMutation, PaymentSetupMutationVariables>(
    'PaymentSetup',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreatePaymentMutationSupay((req, res, ctx) => {
 *   const { merchantId, orderId, paymentProcessorData, payment } = req.variables;
 *   return res(
 *     ctx.data({ createPayment })
 *   )
 * })
 */
export const mockCreatePaymentMutationSupay = (resolver: ResponseResolver<GraphQLRequest<CreatePaymentMutationVariables>, GraphQLContext<CreatePaymentMutation>, any>) =>
  supay.mutation<CreatePaymentMutation, CreatePaymentMutationVariables>(
    'CreatePayment',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetPosTableOrdersQuerySupay((req, res, ctx) => {
 *   const { qr } = req.variables;
 *   return res(
 *     ctx.data({ getPosTableOrders })
 *   )
 * })
 */
export const mockGetPosTableOrdersQuerySupay = (resolver: ResponseResolver<GraphQLRequest<GetPosTableOrdersQueryVariables>, GraphQLContext<GetPosTableOrdersQuery>, any>) =>
  supay.query<GetPosTableOrdersQuery, GetPosTableOrdersQueryVariables>(
    'GetPosTableOrders',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetPosOrderHeaderQuerySupay((req, res, ctx) => {
 *   const { posLocationId, posOrderId, posSystem } = req.variables;
 *   return res(
 *     ctx.data({ getPosOrderHeader })
 *   )
 * })
 */
export const mockGetPosOrderHeaderQuerySupay = (resolver: ResponseResolver<GraphQLRequest<GetPosOrderHeaderQueryVariables>, GraphQLContext<GetPosOrderHeaderQuery>, any>) =>
  supay.query<GetPosOrderHeaderQuery, GetPosOrderHeaderQueryVariables>(
    'GetPosOrderHeader',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetOrderForReceiptQuerySupay((req, res, ctx) => {
 *   const { orderId } = req.variables;
 *   return res(
 *     ctx.data({ getStoreOrder })
 *   )
 * })
 */
export const mockGetOrderForReceiptQuerySupay = (resolver: ResponseResolver<GraphQLRequest<GetOrderForReceiptQueryVariables>, GraphQLContext<GetOrderForReceiptQuery>, any>) =>
  supay.query<GetOrderForReceiptQuery, GetOrderForReceiptQueryVariables>(
    'GetOrderForReceipt',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetOapOrderForReceiptQuerySupay((req, res, ctx) => {
 *   const { orderId } = req.variables;
 *   return res(
 *     ctx.data({ getCompletedOrder })
 *   )
 * })
 */
export const mockGetOapOrderForReceiptQuerySupay = (resolver: ResponseResolver<GraphQLRequest<GetOapOrderForReceiptQueryVariables>, GraphQLContext<GetOapOrderForReceiptQuery>, any>) =>
  supay.query<GetOapOrderForReceiptQuery, GetOapOrderForReceiptQueryVariables>(
    'GetOapOrderForReceipt',
    resolver
  )
